import {
  CalcValueMode,
  CalcValueProps,
  DataCols,
  DataColumn,
  DataColumnRecord,
  DataInputCommonParams,
  DataInputElement,
  DataInputParams,
  dateFormatterEx,
  DatePickerTypeArray,
  InputTypeValue,
  LinkPathName,
  loadingMode,
  PickerType,
  subsLabel,
} from "./inputType";
import { DataParams, ListClickButton, TransitionType } from "@/components/layout/layoutType";
import dayjs, { Dayjs } from "dayjs";
import { checkDebug, Debug } from "@/util/debug";
import { Button, FormInstance, Switch, Tooltip } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { fetchHost, fetchUtil } from "@/util/fetchutil";
import dv from "@datas/default.json";
import { getDBData } from "@/util/code";
import { cn } from "@/lib/utils";
import { checkEmpty, checkEmptyValue } from "@/util/stringutil";
// import dynamic from "next/dynamic";
import { getIntArray } from "@/util/arrayutil";
import { Dispatch, JSX } from "react";

import Icon from "@/components/common/icon/icon";
import { enLocale, koLocale } from "@/i18n/routing";
import { tooltipColor } from "../list/defaultType";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });
const useInitFunction = true;
const useValueListDebug = false;

export function GetDataInputElement(
  params: DataInputElement | string,
  spacingFront: boolean,
  values: any,
  t?: TransitionType,
  inputParams?: DataInputParams,
) {
  const temp: DataInputElement = typeof params === "string" ? { element: params } : params;

  if (temp.display ?? true) {
    const spacing = temp.spacing ?? null;
    let value;
    if (typeof temp.element === "string") {
      if (temp.field ?? false) {
        value = values[temp.element];
      } else {
        value = temp.element;
      }
      if (temp.transition && t) {
        value = t(value);
      }
    } else {
      value = temp.element;
    }

    if (temp.elementType == "icon") {
      value = <Icon iconType="" className={temp.className} {...temp.iconProp} iconName={value} />;
    } else if (temp.elementType == "button") {
      value = (
        <Button
          className={temp.className}
          {...temp.buttonProp}
          onClick={
            inputParams?.onClick
              ? (e) => {
                  if (inputParams.onClick) {
                    inputParams.onClick({
                      key: inputParams.name,
                      value: undefined,
                      name: inputParams.subListName,
                      index: inputParams.index,
                      event: e,
                    });
                  }
                }
              : temp.buttonProp?.onClick
          }
        >
          {spacingFront && temp.fixValue
            ? typeof temp.fixValue === "string" && (temp.transition ?? true) && t
              ? t(temp.fixValue)
              : temp.fixValue
            : undefined}
          {value}
          {!spacingFront && temp.fixValue
            ? typeof temp.fixValue === "string" && (temp.transition ?? true) && t
              ? t(temp.fixValue)
              : temp.fixValue
            : undefined}
        </Button>
      );
    } else if (temp.elementType == "switch") {
      const value_null = value === undefined || (typeof value === "string" && value.trim() === "");
      const switchClass = temp.switchProp?.className ?? "";
      if (temp.switchFront) {
        value = (
          <>
            <Switch {...temp.switchProp} className={cn(!value_null ? "mr-2" : "", temp.className, switchClass)} />
            {value}
          </>
        );
      } else {
        value = (
          <>
            {value}
            <Switch {...temp.switchProp} className={cn(!value_null ? "ml-2" : "", temp.className, switchClass)} />
          </>
        );
      }
    }
    const tooltip = temp.tooltip ? (t && (temp.tooltipTransition ?? true) ? t(temp.tooltip) : temp.tooltip) : undefined;
    if (
      (typeof value === "string" || typeof value === "number") &&
      (typeof spacing === "string" || typeof spacing === "number" || spacing === null)
    ) {
      const temp_value = spacingFront ? (spacing ?? "" + value) : value + (spacing ?? "");
      if (tooltip) {
        return (
          <Tooltip color={tooltipColor} title={tooltip} placement={temp.tooltipPlacement ?? "topLeft"} {...temp.tooltipProps}>
            {temp_value}
          </Tooltip>
        );
      } else {
        return temp_value;
      }
    } else {
      const temp_value = spacingFront ? (
        <>
          {spacing}
          {value}
        </>
      ) : (
        <>
          {value}
          {spacing}
        </>
      );
      if (tooltip) {
        return (
          <Tooltip color={tooltipColor} title={tooltip} placement={temp.tooltipPlacement ?? "topLeft"} {...temp.tooltipProps}>
            {temp_value}
          </Tooltip>
        );
      } else {
        return temp_value;
      }
    }
  } else {
    return null;
  }
}

export const GetUnitElement = (value: string | number, unitPrevObj: JSX.Element | string, unitObj: JSX.Element | string) => {
  let result: string | JSX.Element = value + "";
  if (typeof unitPrevObj === "string" && typeof unitObj === "string") {
    result = unitPrevObj + result + unitObj;
  } else if (typeof unitPrevObj == "string") {
    result = unitPrevObj + result;
  } else if (typeof unitObj == "string") {
    result = result + unitObj;
  }
  if (typeof unitPrevObj != "string" && typeof unitObj != "string") {
    result = (
      <>
        {unitPrevObj}
        {result}
        {unitObj}
      </>
    );
  } else if (typeof unitPrevObj != "string") {
    result = (
      <>
        {unitPrevObj}
        {result}
      </>
    );
  } else if (typeof unitObj != "string") {
    result = (
      <>
        {result}
        {unitObj}
      </>
    );
  }
  return result;
};
export const getDatePicker = (inputType?: string): PickerType => {
  const result: PickerType = { picker: undefined, range: false, showTime: false, timePicker: false, multiple: false, mode: undefined };
  switch (inputType) {
    case "dateMulti":
      return { ...result, multiple: true };
    case "weekMulti":
      return { ...result, multiple: true, picker: "week", mode: "week" };
    case "monthMulti":
      return { ...result, multiple: true, picker: "month", mode: "month" };
    case "quarterMulti":
      return { ...result, multiple: true, picker: "quarter", mode: "quarter" };
    case "yearMulti":
      return { ...result, multiple: true, picker: "year", mode: "year" };
    case "timeRange":
      return { ...result, timePicker: true, range: true, mode: "time" };
    case "datetimeRange":
      return { ...result, showTime: true, range: true, mode: "date" };
    case "dateRange":
      return { ...result, range: true, picker: "date", mode: "date" };
    case "weekRange":
      return { ...result, range: true, picker: "week", mode: "week" };
    case "monthRange":
      return { ...result, range: true, picker: "month", mode: "month" };
    case "quarterRange":
      return { ...result, range: true, picker: "quarter", mode: "quarter" };
    case "yearRange":
      return { ...result, range: true, picker: "year", mode: "year" };
    case "time":
      return { ...result, timePicker: true, mode: "time" };
    case "week":
      return { ...result, picker: "week", mode: "week" };
    case "month":
      return { ...result, picker: "month", mode: "month" };
    case "quarter":
      return { ...result, picker: "quarter", mode: "quarter" };
    case "year":
      return { ...result, picker: "year", mode: "year" };
    case "datetime":
      return { ...result, showTime: true };
    case "date":
    default:
      return result;
  }
};

export const getInputParams = (params: DataInputParams) => {
  switch (params.inputMode) {
    case "write":
      if (params.edit) {
        if (params.create) {
          return { ...params.edit, ...params.create };
        } else {
          return params.edit;
        }
      } else {
        return params.create;
      }
    case "edit":
      if (params.edit) {
        if (params.update) {
          return { ...params.edit, ...params.update };
        } else {
          return params.edit;
        }
      } else {
        return params.update;
      }
    case "view":
    default:
      return params.read;
  }
};
export const getInputCommonParams = (inputMode: string, params: DataInputCommonParams) => {
  switch (inputMode) {
    case "write":
      if (params.edit) {
        if (params.create) {
          return { ...params.edit, ...params.create };
        } else {
          return params.edit;
        }
      } else {
        return params.create;
      }
    case "edit":
      if (params.edit) {
        if (params.update) {
          return { ...params.edit, ...params.update };
        } else {
          return params.edit;
        }
      } else {
        return params.update;
      }
    case "view":
    default:
      return params.read;
  }
};
export const getDayjs = (value: any, inputType?: string, joinStr?: string): dayjs.Dayjs | dayjs.Dayjs[] => {
  const str = joinStr ?? ",";
  if (typeof value == "string") {
    if (value.indexOf(str) > 0) {
      const dv = value.split(str).map((i) => {
        return getDayjsCommon(i, inputType);
      });
      return dv;
    } else {
      return getDayjsCommon(value, inputType);
    }
  } else if (value instanceof Array) {
    const dv = value.map((i) => {
      return getDayjsCommon(i, inputType);
    });
    return dv;
  } else {
    return getDayjsCommon(value, inputType);
  }
};
export const getDayjsCommon = (value: string | number, inputType?: string, dash?: boolean, reverse?: boolean): dayjs.Dayjs => {
  let format = undefined;
  const check_dash = dash !== undefined ? dash : typeof value === "string" && value.indexOf("-") > 0 ? true : false;
  switch (inputType) {
    case "yearMulti":
    case "yearRange":
    case "year":
      format = "YYYY";
      break;
    case "quarterMulti":
    case "quarter":
    case "quarterRange":
      format = check_dash ? "YYYY-Q" : "YYYYQ";
      break;
    case "monthMulti":
    case "monthRange":
    case "month":
      format = check_dash ? "YYYY-MM" : "YYYYMM";
      break;
    case "weekMulti":
    case "week":
    case "weekRange":
      format = check_dash ? "YYYY-ww" : "YYYYww";
      break;
    case "dateMulti":
    case "dateRange":
    case "date":
      format = check_dash ? "YYYY-MM-DD" : "YYYYMMDD";
      break;
    case "timeRange":
    case "time":
      if (typeof value === "number") {
        if (reverse) {
          return dayjs(value - dayjs().utcOffset() * 60000);
        } else {
          return dayjs((value < 0 ? Math.abs(value) : value) - dayjs().utcOffset() * 60000);
        }
      } else {
        format = check_dash ? "HH:mm:ss" : "HHmmss";
      }
      break;
    case "datetimeRange":
    case "datetime":
    default:
      break;
  }
  if (format) {
    return dayjs(value + "", format);
  } else {
    return dayjs(value);
  }
};
export const getDayjsFirst = (value: any, joinStr?: string): dayjs.Dayjs | undefined => {
  const str = joinStr ?? ",";
  if (value === undefined || value === null) {
    return undefined;
  } else if (typeof value == "string") {
    if (value.indexOf(str) > 0) {
      const [dv] = value.split(str);
      return dayjs(dv);
    } else {
      return dayjs(value);
    }
  } else if (value instanceof Array) {
    const [dv] = value;
    if (dv) {
      return dayjs(dv);
    } else {
      return undefined;
    }
  } else {
    return dayjs(value);
  }
};
export const getDayjsStr = (value: dayjs.Dayjs | dayjs.Dayjs[] | undefined, formatter?: string, joinStr?: string) => {
  if (value === undefined) {
    return undefined;
  } else if (value instanceof Array) {
    return value
      .map((i) => {
        return i.format(formatter);
      })
      .join(joinStr ?? ",");
  } else {
    return value.format(formatter);
  }
};
export const getDayjsRange = (
  value: dayjs.Dayjs | dayjs.Dayjs[] | undefined,
): [start: dayjs.Dayjs | null | undefined, end: dayjs.Dayjs | null | undefined] | undefined => {
  if (value === undefined) {
    return undefined;
  } else if (value instanceof Array) {
    if (value.length > 1) {
      return [value[0], value[value.length - 1]];
    } else {
      return [value[0], null];
    }
  } else {
    return [value, null];
  }
};
export const getDayjsValueStr = (value: Dayjs | Dayjs[], inputType?: string, dash?: boolean, dateFormatter?: dateFormatterEx) => {
  if (value instanceof Array) {
    return value
      .map((item) => {
        return getDayjsValueStrCommon(item, inputType, dash, dateFormatter);
      })
      .join(",");
  } else {
    return getDayjsValueStrCommon(value, inputType, dash, dateFormatter);
  }
};
export const getDayjsValueStrCommon = (value: Dayjs, inputType?: string, dash?: boolean, dateFormatter?: dateFormatterEx) => {
  if (dateFormatter && typeof dateFormatter === "string") {
    return value.format(dateFormatter);
  }
  switch (inputType) {
    case "yearMulti":
    case "yearRange":
    case "year":
      return value.year();
    case "quarterMulti":
    case "quarter":
    case "quarterRange":
      return dash ? value.format("YYYY-Q") : value.format("YYYYQ");
    case "monthMulti":
    case "monthRange":
    case "month":
      return dash ? value.format("YYYY-MM") : value.format("YYYYMM");
    case "weekMulti":
    case "week":
    case "weekRange":
      return dash ? value.format("YYYY-ww") : value.format("YYYYww");
    case "dateMulti":
    case "dateRange":
    case "date":
      return dash ? value.format("YYYY-MM-DD") : value.format("YYYYMMDD");
    case "timeRange":
    case "time":
      const dayjsvalue = dayjs(value.valueOf() + dayjs().utcOffset() * 60000);
      if (dateFormatter) {
        if (typeof dateFormatter === "string") {
          return dayjsvalue.format(dateFormatter);
        } else {
          // Debug("getDayjsValueStrCommon", dayjsvalue.valueOf());
          if (dayjsvalue.valueOf() < 60000 && dateFormatter.second) {
            return dayjsvalue.format(dateFormatter.second);
          } else if (dayjsvalue.valueOf() < 3600000 && dateFormatter.minute) {
            if (dayjsvalue.second() === 0 && dateFormatter.minuteZ) {
              return dayjsvalue.format(dateFormatter.minuteZ);
            } else {
              return dayjsvalue.format(dateFormatter.minute);
            }
          } else if (dateFormatter.hour) {
            if (dayjsvalue.second() === 0) {
              if (dayjsvalue.minute() === 0 && dateFormatter.hourZZ) {
                return dayjsvalue.format(dateFormatter.hourZZ);
              } else if (dateFormatter.hourzZ) {
                return dayjsvalue.format(dateFormatter.hourzZ);
              }
            } else if (dayjsvalue.minute() === 0) {
              if (dateFormatter.hourZz) {
                return dayjsvalue.format(dateFormatter.hourZz);
              }
            }
            return dayjsvalue.format(dateFormatter.hour);
          } else {
            return dayjsvalue.valueOf();
          }
        }
      } else {
        return dayjsvalue.valueOf();
      }
    case "datetimeRange":
    case "datetime":
    default:
      // if (dateFormatter !== undefined) {
      //   return dayjs(value.valueOf() + dayjs().utcOffset() * 60000).format(dateFormatter);
      // } else {
      //   return dayjs(value.valueOf() + dayjs().utcOffset() * 60000)
      //     .toISOString()
      //     .replace(/Z$/, "+00:00")
      //     .replace(/[.]000[+]00:00$/, "");
      // }
      if (dateFormatter !== undefined && typeof dateFormatter === "string") {
        return value.format(dateFormatter);
      } else {
        // Debug("dateFormatter !== undefined", value.toISOString());
        // return value.toISOString().replace(/Z$/, "+00:00");
        return value.utc().format("YYYY-MM-DDTHH:mm:ssZ");
      }
      break;
  }
};
export const defaultFloatFomatter = (value?: any, info?: { userTyping: boolean; input: string }) => {
  // Debug("defaultFloatFomatter", value);
  if (info?.userTyping) {
    return info.input;
  } else {
    if (checkEmpty(value)) {
      return "";
    } else if (value === Math.floor(value)) {
      return Math.floor(value);
    } else {
      return value;
    }
  }
};

export const checkNoItem = (params: DataInputParams) => {
  return params.noItem ?? params.inputMode === "view";
};
export const getPlaceholder = (t: TransitionType, params: DataInputParams, disabled?: boolean) => {
  return (
    (!params.placeholderForce && params.inputMode === "view" && (!(disabled ?? false) || !params.readOnly) ? "" : undefined) ??
    (params.placeholder
      ? params.placeholderTransition === undefined || params.placeholderTransition === true
        ? t(params.placeholder)
        : params.placeholder
      : undefined)
  );
};

export const getTooltip = (t: TransitionType, params: DataInputParams) => {
  const tooltip_str =
    typeof params.tooltip === "string" ? (params.tooltipField ? getInputFieldValue(params, params.tooltip) : params.tooltip) : undefined;
  //Debug("getTooltip", params.tooltip, params.name, tooltip_str, params.inputType, getSelectTooltipStr(params, undefined));
  return params.tooltip
    ? tooltip_str
      ? params.tooltipTransition || (params.tooltipTransition === undefined && !params.tooltipField)
        ? t(tooltip_str)
        : tooltip_str
      : params.inputType === "select" || params.inputType === "selectSearch"
        ? (getSelectTooltipStr(params, undefined) ?? getPlaceholder(t, params, false))
        : getPlaceholder(t, params, false)
    : undefined;
};
export const calcValue = (values: any, prop: CalcValueProps) => {
  if (prop instanceof Function) {
    return prop(values);
  } else {
    const a: any =
      typeof prop.input1 === "number"
        ? prop.input1
        : typeof prop.input1 === "string"
          ? values[prop.input1]
          : calcValue(values, prop.input1);
    const b: any =
      typeof prop.input2 === "number"
        ? prop.input2
        : typeof prop.input2 === "string"
          ? values[prop.input2]
          : calcValue(values, prop.input2);
    // const a:any = typeof prop.input1 === "string" ? values[prop.input1] : undefined;
    // const b:any = typeof prop.input2 === "string" ? values[prop.input2] : undefined;

    let calc = undefined;

    if (a !== undefined && a !== null && b !== undefined && b !== null) {
      switch (prop.mode) {
        case "+":
          calc = a + b;
          break;
        case "-":
          calc = a - b;
          break;
        case "*":
          calc = a * b;
          break;
        case "/":
          if (b !== 0) {
            calc = a / b;
          }
          break;
        case "dtr":
          if (a !== 0) {
            calc = ((a - b) / a) * 100;
          }
          break;

        case "loss":
          if (b !== 0) {
            calc = (1 - a / b) * 100;
          }
          break;
        default:
          break;
      }
    }
    if (calc !== undefined) {
      if (prop.scale) {
        calc = Number(calc) * prop.scale;
      }
      if (prop.fixed) {
        calc = Number(calc).toFixed(prop.fixed);
      }
    }
    // Debug("calcValue : " + prop.input1 + "(" + a + ") " + prop.mode + " " + prop.input2 + " (" + b + ") =  " + calc);
    return calc;
  }
  //values: any, input1: string, mode: string, input2: string, fixed?: number, scale?: number
};
export const calcFieldsValue = (
  form: FormInstance<any> | undefined,
  input1: string,
  mode: CalcValueMode,
  input2: string,
  result: string,
  fixed?: number,
  scale?: number,
) => {
  if (form) {
    const values = form.getFieldsValue([input1, input2, result]);
    const c = form.getFieldValue(result);
    let calc = calcValue(values, { input1, mode, input2, fixed, scale });
    // Debug(input1, mode, input2, values, result, c);
    if (c !== calc) {
      const setValues: Record<string, any> = {};
      setValues[result] = calc !== undefined && !isNaN(calc) ? calc : null;
      // form.setFieldValue(result, calc !== undefined && !isNaN(calc) ? calc : null);
      form.setFieldsValue(setValues);
    }
  }
};
export const getParamFields = (params: DataInputParams, typeCheck?: boolean): Record<string, DataInputCommonParams> => {
  const result: Record<string, DataInputCommonParams> = {};
  if (params.fieldId && typeof params.fieldId !== "string") {
    if (params.subList && params.name !== undefined) {
      result[params.name] = params;
    }
    if (params.inputType !== "summary") {
      getParamsFieldsCommon(params, result, typeCheck);
    }
  } else {
    result[typeof params.fieldId === "string" ? params.fieldId : (params.name ?? "")] = { ...params };
  }
  return result;
};

export const getParamsFieldsCommon = (
  params: DataInputParams | DataInputCommonParams,
  result: Record<string, DataInputCommonParams>,
  typeCheck?: boolean,
) => {
  if (params.fieldId && typeof params.fieldId !== "string") {
    for (const [key, value] of Object.entries(params.fieldId)) {
      if (!typeCheck || value.inputType || value.valueType) {
        result[key] = value;
      }
      if (value.inputType !== "summary") {
        getParamsFieldsCommon(value, result, typeCheck);
      }
    }
  }
};
export const getNumber = (value: any, defaultValue: number) => {
  const result = Number(value);
  return isNaN(result) ? defaultValue : result;
};
export const addColsFieldId = (
  cols: DataColumnRecord,
  fieldIds: Record<string, Record<string, DataInputCommonParams>>[],
): DataColumnRecord => {
  const newCols: DataColumnRecord = JSON.parse(JSON.stringify(cols));
  if (newCols) {
    fieldIds.forEach((item) => {
      const keys = Object.keys(item);
      keys.forEach((key) => {
        const temp_fieldIds = item[key];
        const fieldKeys = Object.keys(temp_fieldIds);
        fieldKeys.forEach((fieldKey) => {
          const newColsKey = newCols[key];
          if (newColsKey && newColsKey.fieldId !== undefined && typeof newColsKey.fieldId !== "string") {
            newColsKey.fieldId[fieldKey] = temp_fieldIds[fieldKey];
          }
        });
      });
    });
  }
  return newCols;
};

export const delColsFieldId = (cols: DataColumnRecord, fieldIds: Record<string, string[]>[]): DataColumnRecord => {
  const newCols: DataColumnRecord = JSON.parse(JSON.stringify(cols));
  if (newCols) {
    fieldIds.forEach((item) => {
      const keys = Object.keys(item);
      keys.forEach((key) => {
        const temp_fieldIds = item[key];
        temp_fieldIds.forEach((fieldKey) => {
          const newColsKey = newCols[key];
          if (newColsKey && newColsKey.fieldId !== undefined && typeof newColsKey.fieldId !== "string") {
            delete newColsKey.fieldId[fieldKey];
          }
        });
      });
    });
  }
  return newCols;
};

export const getCodeLabel = (params: DataInputParams, insertEtc?: boolean) => {
  const joinPrev = params.codeGroupJoinPrev ?? " - ";
  const joinNext = params.codeGroupJoinNext ?? "";
  const label_id = params.codeGroupLabel ?? (params.locale === koLocale ? "code_name_kr" : "code_name");
  //params.input;
  if (params.codeGroup && params.codeGroups && params.codeGroups[params.codeGroup]) {
    const join_str = params.valueJoin ?? ",";
    const temp_value =
      (params.selectProp?.mode === "multiple" || params.selectProp?.mode === "tags") && typeof params.value === "string"
        ? params.value.split(join_str)
        : params.value;
    if (temp_value instanceof Array) {
      const temp_value_list = temp_value.map((item) => {
        if (item === dv.input_direct) {
          if (params.inputDirect) {
            const target_name = typeof params.inputDirect === "string" ? params.inputDirect : params.inputDirect?.target;
            return params.values && params.values[target_name] ? params.values[target_name] : "";
          } else {
            return "";
          }
        } else {
          if (params.codeGroup && params.codeGroups && params.codeGroups[params.codeGroup]) {
            for (const code of params.codeGroups[params.codeGroup]) {
              if (code.code_id === item) {
                return getCodeItemLabel(code, label_id, joinPrev, joinNext, params.locale);
              }
            }
          }
        }
      });
      if (insertEtc && params.inputDirect) {
        const target_name = typeof params.inputDirect === "string" ? params.inputDirect : params.inputDirect?.target;
        const target_value = target_name && params.values && params.values[target_name] ? params.values[target_name] : undefined;
        if (!checkEmpty(target_value)) {
          temp_value_list.push(target_value);
        }
        if (useValueListDebug) Debug(temp_value_list, target_name);
      }
      return temp_value_list.join(join_str);
    } else {
      if (params.value === dv.input_direct) {
        if (params.inputDirect) {
          const target_name = typeof params.inputDirect === "string" ? params.inputDirect : params.inputDirect?.target;
          return params.values && params.values[target_name] ? params.values[target_name] : "";
        } else {
          return "";
        }
      } else {
        for (const code of params.codeGroups[params.codeGroup]) {
          if (code.code_id == params.value) {
            return getCodeItemLabel(code, label_id, joinPrev, joinNext, params.locale);
          }
        }
      }
    }
  }
  return params.value;
};
const getCodeItemLabel = (item: any, label_id: string | string[], joinPrev: string, joinNext: string, locale?: string) => {
  if (label_id instanceof Array) {
    const label = label_id.map((id, index) => {
      return index == 0 ? item[id] : joinPrev + item[id] + joinNext;
    });
    return label;
  } else {
    const label =
      label_id === "feat"
        ? locale === enLocale || !item.code_name_kr || item.code_name_kr === item.code_name
          ? item.code_name
          : item.code_name_kr + joinPrev + item.code_name + joinNext
        : (item[label_id] ?? item.code_name);
    return label;
  }
};
const getDataValueList = (
  data: any,
  obj: {
    label: string | subsLabel | (string | subsLabel)[];
    value: string;
    labelJoin?: string | string[];
    labelJoinNext?: string | string[];
    labelSort?:
      | -1
      | boolean
      | ((
          a: { value: any; label: string | JSX.Element; label_str: string },
          b: { value: any; label: string | JSX.Element; label_str: string },
        ) => number);
  },
) => {
  const label_list = obj.label instanceof Array ? obj.label : [obj.label];
  if (data && data instanceof Array) {
    const result: { value: any; label: JSX.Element; label_str: string }[] = data.map((temp_data: any) => {
      let temp_label = "";
      label_list.forEach((label_item, index) => {
        let temp_label_item = "";
        const temp_labelJoin = obj.labelJoin
          ? typeof obj.labelJoin === "string"
            ? index !== 0 && temp_label !== ""
              ? obj.labelJoin
              : ""
            : obj.labelJoin[index]
          : index !== 0 && temp_label !== ""
            ? " - "
            : "";
        const temp_labelJoinNext = obj.labelJoinNext
          ? typeof obj.labelJoinNext === "string"
            ? index !== 0 && temp_label !== ""
              ? obj.labelJoin
              : ""
            : obj.labelJoinNext[index]
          : "";

        if (typeof label_item === "string") {
          if (!checkEmpty(temp_data[label_item])) {
            temp_label_item += temp_data[label_item];
          }
        } else {
          const temp_label =
            temp_data[label_item.field] && temp_data[label_item.field] !== ""
              ? temp_data[label_item.field]
              : temp_data[label_item.subs] && temp_data[label_item.subs] !== ""
                ? temp_data[label_item.subs]
                : "";
          if (!checkEmpty(temp_label)) {
            temp_label_item += temp_label;
          }
        }
        if (temp_label_item !== "") {
          temp_label += temp_labelJoin + temp_label_item + temp_labelJoinNext;
        }
      });
      return { value: temp_data[obj.value], label: <span data-value={temp_data[obj.value]}>{temp_label}</span>, label_str: temp_label };
    });
    if (obj.labelSort !== undefined) {
      if (obj.labelSort instanceof Function) {
        const sortFunction = obj.labelSort;
        result.sort(sortFunction);
      } else {
        if (obj.labelSort === -1) {
          result.sort((a, b) => {
            return b.label_str.localeCompare(a.label_str); //a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
          });
        } else if (obj.labelSort) {
          result.sort((a, b) => {
            return a.label_str.localeCompare(b.label_str); //a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
          });
        }
      }
    }
    return result;
    // return result.map((item) => {
    //   return { value: item.value, label: <span data-value={item.value}>{item.label}</span> };
    // });
  } else {
    return [];
  }
};
export const checkColsValueListChange = (org: DataColumn[] | undefined, change: DataColumn[] | undefined) => {
  if (org === change || (org === undefined && change === undefined)) {
    return false;
  } else if (org === undefined || change === undefined) {
    return true;
  } else {
    if (org.length !== change.length) {
      return true;
    } else {
      return org.some((orgItem, index) => {
        const changeItem = change[index];
        if (changeItem.valueList === orgItem.valueList) {
          return false;
        } else if (changeItem.valueList === undefined || orgItem.valueList === undefined) {
          return true;
        } else {
          const order_valueList = orgItem.valueList;
          if (changeItem.valueList.length !== orgItem.valueList.length) {
            return true;
          } else {
            //같은게 없음F
            return changeItem.valueList.some((item) => {
              const change_value = item.value;
              //같은게 있음
              const check = order_valueList.some((order) => {
                return order.value === change_value;
              });
              return !check;
            });
          }
        }
      });
    }
  }
};
const getSelectTooltipStr = (params: DataInputParams, value_list: any[] | undefined): string | undefined => {
  const value = getInputValue(params);
  if (!checkEmpty(value)) {
    const check_value_list = value_list ?? runFormFunction(params.formFunction, params.name, "getValueList").result;
    if (check_value_list instanceof Array) {
      const str =
        value instanceof Array
          ? check_value_list
              .filter((item) => value.includes(item.value))
              .map((item) => item.label_str ?? item.label)
              .join(params.valueJoin ?? ",")
          : check_value_list
              .filter((item) => value === item.value)
              .map((item) => item.label_str ?? item.label)
              .join(params.valueJoin ?? ",");
      return str;
    }
  }
  return undefined;
};
export const setEmptyValue = (params: DataInputParams, valueList: any[] | undefined) => {
  if (params.selectPropOption?.setEmptyValue !== undefined) {
    const i =
      typeof params.selectPropOption.setEmptyValue === "boolean"
        ? params.selectPropOption.setEmptyValue
          ? 0
          : undefined
        : params.selectPropOption.setEmptyValue;
    if (i !== undefined) {
      const key = params.name;
      if (params.form && key) {
        const check_value = params.form.getFieldValue(key);
        const include =
          !checkEmpty(check_value) && valueList
            ? valueList.some((value) => {
                return check_value === value.value;
              })
            : false;
        const setValues: Record<string, any> = {};
        if (!include && valueList !== undefined && valueList.length > 0) {
          const check_i = i !== undefined && (i === -1 || i >= valueList.length) ? valueList.length - 1 : (i ?? 0);
          // params.form.setFieldValue(key, valueList[check_i].value);
          setValues[key] = valueList[check_i].value;
        } else {
          if (valueList === undefined || valueList.length === 0) {
            // params.form.setFieldValue(key, undefined);
            setValues[key] = undefined;
          }
        }
        if (!checkEmpty(setValues)) {
          params.form.setFieldsValue(setValues);
        }
      }
    }
  }
};
export const setSelectTooltip = (params: DataInputParams, value_list: any[] | undefined) => {
  if (typeof params.tooltip === "boolean" && params.tooltip) {
    const str = getSelectTooltipStr(params, value_list);
    //Debug("setSelectTooltip", str, params.name);
    setTimeout(() => {
      runFormFunction(params.formFunction, params.name, "setTooltip", str);
    }, dv.setTimeoutDelay);
  }
};
export const getInputValuesCheck = (
  form: FormInstance<any> | undefined,
  formMemo: Record<string, any> | undefined,
  dataFunction: Record<string, Function> | undefined,
  values: any,
  fields: string[] | Record<string, DataInputCommonParams>,
  reverseConvert?: boolean,
) => {
  const fieldList = fields instanceof Array ? fields : Object.keys(fields);
  const fieldIds = fields instanceof Array ? undefined : fields;
  const result = form?.getFieldsValue(fieldList);
  const exFields = fieldList.filter((item) => result[item] === undefined);
  const temp_values = values ?? (dataFunction && dataFunction["getData"] ? dataFunction["getData"]() : undefined);
  // Debug("getInputValuesCheck : " + (values ? "values" : "getData") + " : ", temp_values);
  if (reverseConvert) {
    const resultKeys = Object.keys(result);
    resultKeys.forEach((field) => {
      const dateFormatter = fieldIds ? fieldIds[field].dateFormatter : undefined;
      if (temp_values !== undefined) {
        const memoKey = formMemo && formMemo[field] ? formMemo[field] : undefined;
        const inputType = memoKey ? memoKey.inputType : undefined;
        const convertScale: number | undefined = memoKey ? memoKey["convertScale"] : undefined;
        const orgValue = result[field];
        result[field] = convertInputTypeValue(orgValue, inputType, convertScale, dateFormatter, reverseConvert);
        // Debug(field, inputType, result[field], orgValue);
      } else {
        result[field] = getInputValueCheck(form, formMemo, dataFunction, temp_values, field, reverseConvert, dateFormatter);
      }
    });
  }
  if (exFields.length > 0) {
    // Debug("getInputValuesCheck exFields start");
    exFields.forEach((field) => {
      const dateFormatter = fieldIds ? fieldIds[field].dateFormatter : undefined;
      const memoKey = formMemo && formMemo[field] ? formMemo[field] : undefined;
      const inputType = memoKey ? memoKey.inputType : undefined;
      // const convertScale: number | undefined = memoKey ? memoKey["convertScale"] : undefined;
      const orgValue = temp_values[field];
      if (DatePickerTypeArray.includes(inputType) && typeof orgValue === "number") {
        result[field] = convertInputTypeValue(orgValue, "number", undefined, undefined, false);
      } else {
        result[field] = convertInputTypeValue(orgValue, inputType, undefined, dateFormatter, reverseConvert);
      }
      // Debug("getInputValuesCheck field : " + field, inputType, typeof orgValue, orgValue, result[field], dateFormatter);
    });
    // Debug("getInputValuesCheck exFields end");
  }

  return result;
};
export const getInputValueCheck = (
  form: FormInstance<any> | undefined,
  formMemo: Record<string, any> | undefined,
  dataFunction: Record<string, Function> | undefined,
  values: any,
  field: string,
  reverseConvert?: boolean,
  dateFormatter?: dateFormatterEx,
) => {
  if (form && form.getFieldInstance(field)) {
    const value = form.getFieldValue(field);
    if (reverseConvert) {
      if (dataFunction && dataFunction["getData"]) {
        const temp_values = values ?? dataFunction["getData"]();
        if (temp_values !== undefined) {
          const memoKey = formMemo && formMemo[field] ? formMemo[field] : undefined;
          const inputType = memoKey ? memoKey.inputType : undefined;
          const convertScale: number | undefined = memoKey ? memoKey["convertScale"] : undefined;
          return convertInputTypeValue(value, inputType, convertScale, dateFormatter, reverseConvert);
        }
      }
    }
    return value;
  } else {
    // Debug("getInputValueCheck ", form?.getFieldInstance(field), form?.getFieldValue(field));
    const temp_values = values ?? (dataFunction && dataFunction["getData"] ? dataFunction["getData"]() : undefined);
    if (temp_values !== undefined) {
      const memoKey = formMemo && formMemo[field] ? formMemo[field] : undefined;
      const inputType = memoKey ? memoKey.inputType : undefined;
      const convertScale: number | undefined = memoKey ? memoKey["convertScale"] : undefined;
      const value = convertInputTypeValue(temp_values[field], inputType, convertScale, dateFormatter, reverseConvert);
      return value;
    }
  }
  return undefined;
};
export const setFormClass = (dataFunction: Record<string, Function> | undefined, condition: Record<string, any>) => {
  if (dataFunction) {
    Debug("dataFunction SetFormClass", condition);

    const addClassName: string[] = [];
    const removeClassName: string[] = [];
    Object.keys(condition).forEach((key) => {
      const check = condition[key];
      if (check) {
        addClassName.push(key);
      } else {
        removeClassName.push(key);
      }
    });
    // Debug(addClassName, removeClassName);
    if (!checkEmpty(addClassName) || !checkEmpty(removeClassName)) {
      dataFunction["setFormClass"](addClassName, removeClassName);
    }
  } else {
    Debug("dataFunction is null");
  }
};
export const getFieldValue = (form: FormInstance<any> | undefined, field: string, values: any) => {
  const value = form && form.getFieldInstance(field) ? form.getFieldValue(field) : values[field];
  return value;
};
export const getInputValue = (params: DataInputParams) => {
  const value = params.form && params.form.getFieldInstance(params.name) ? params.form.getFieldValue(params.name) : params.value;
  return value;
};
export const getValueListSelectData = (params: DataInputParams) => {
  const result =
    params.formMemo && params.name && params.formMemo[params.name] && params.formMemo[params.name].data
      ? params.formMemo[params.name].data.result
      : [];

  const filter_result = params.dataUrl || params.dataValueList ? valueListFiltering(params, result, "filter") : result;
  if (!checkEmpty(filter_result)) {
    params.dataLabel?.value ?? "value";
    const value_field = params.dataLabel?.value ?? (params.codeGroup ? "code_id" : "value");
    const value = getInputValue(params);
    let data: any = undefined;

    if (value !== null && value !== undefined && filter_result && filter_result instanceof Array) {
      filter_result.some((item) => {
        if (item[value_field] === value) {
          data = item;
          return true;
        } else {
          return false;
        }
      });
    }
    return data;
  } else {
    return undefined;
  }
};
const setInputDirectShow = (
  form: FormInstance<any> | undefined,
  target: string | { target: string; query?: string; autoFocus?: boolean } | undefined,
  show: boolean,
) => {
  if (target) {
    const obj = { target: "", query: "", autoFocus: true };
    if (typeof target == "string") {
      obj.target = target;
      obj.query = "#" + obj.target;
    } else {
      obj.target = target.target;
      obj.query = target.query ?? "#" + obj.target;
      obj.autoFocus = target.autoFocus ?? true;
    }
    const input = form?.getFieldInstance(obj.target);
    const hiddenTarget = document.querySelectorAll(obj.query);
    if (input) {
      if (show) {
        input.nativeElement.classList.remove("hidden");
      } else {
        input.nativeElement.classList.add("hidden");
      }
    }
    if (show) {
      hiddenTarget.forEach((item) => {
        item.classList.remove("hidden");
      });
    } else {
      hiddenTarget.forEach((item) => {
        item.classList.add("hidden");
      });
    }
  }
};
//
export const convertFormValues = (formMemo: Record<string, any> | undefined, values: any, inFields?: string[], exFields?: string[]) => {
  if (!checkEmpty(values)) {
    const result: Record<string, any> = {};
    Object.keys(values).forEach((key) => {
      if ((!inFields || inFields.includes(key)) && (!exFields || !exFields.includes(key))) {
        const memoKey = formMemo && formMemo[key] ? formMemo[key] : undefined;
        const inputType = memoKey ? memoKey.inputType : undefined;
        const convertScale: number | undefined = memoKey ? memoKey["convertScale"] : undefined;
        result[key] = convertInputTypeValue(values[key], inputType, convertScale);
        // if (key === "brewing_grinder_zeropoint") {
        //   Debug("convertInputTypeValue", values[key], result[key], inputType, convertScale);
        // }
      }
    });
    return result;
  } else {
    return undefined;
  }
};

//form에 맞는 데이터로 변경과 동시에 select muilti의 input direct 값 변경
export const getMatchingData = (
  form: FormInstance<any> | undefined,
  formMemo: Record<string, any> | undefined,
  data: any,
  exField?: string[],
  matching?: string[] | Record<string, string>,
) => {
  //Debug(formMemo);
  let result: Record<string, any> = {};
  if (matching) {
    if (matching instanceof Array) {
      matching.forEach((key) => {
        if (!(exField && exField.includes(key))) {
          const item = key;
          getMatchingDataCommon(form, formMemo, key, item, data, result);
        }
      });
    } else {
      Object.keys(matching).forEach((key) => {
        if (!(exField && exField.includes(key))) {
          const item = matching[key];
          getMatchingDataCommon(form, formMemo, key, item, data, result);
        }
      });
    }
  } else {
    if (!checkEmpty(data)) {
      Object.keys(data).forEach((key) => {
        if (!(exField && exField.includes(key))) {
          const item = key;
          getMatchingDataCommon(form, formMemo, key, item, data, result);
        }
      });
    }
  }
  return result;
};
const getMatchingDataCommon = (
  form: FormInstance<any> | undefined,
  formMemo: Record<string, any> | undefined,
  key: string,
  item: string,
  data: any,
  resultData: Record<string, any>,
) => {
  if (data === undefined) {
    return;
  }
  const temp_data = data[item];
  if (!checkEmpty(temp_data)) {
    const inputType = formMemo && formMemo[key] ? formMemo[key].inputType : undefined;
    const convertScale: number | undefined = formMemo && formMemo[key] ? formMemo[key]["convertScale"] : undefined;
    if (typeof temp_data === "number") {
      resultData[key] = convertInputTypeValue(temp_data, inputType, convertScale);
    } else if (
      formMemo &&
      formMemo[key] &&
      formMemo[key].selectMode !== undefined &&
      (formMemo[key].selectMode === "multiple" || formMemo[key].selectMode === "tags")
    ) {
      const join = formMemo[key].valueJoin ?? ",";
      const inputDirect = formMemo && formMemo[key] ? formMemo && formMemo[key].inputDirect : undefined;
      const target = typeof inputDirect === "string" ? inputDirect : inputDirect instanceof Object ? inputDirect.target : undefined;
      if (inputDirect && target) {
        if (!checkEmpty(data[target])) {
          //resultData[key] = temp_data.split(join).push(dv.input_direct);
          resultData[key] = [...temp_data.split(join), dv.input_direct];
          setInputDirectShow(form, inputDirect, true);
          Debug("checkEmpty", data[target]);
        } else {
          Debug("temp_data", temp_data);
          resultData[key] = temp_data.split(join);
          setInputDirectShow(form, inputDirect, false);
        }
      } else {
        resultData[key] = temp_data.split(join);
      }
    } else {
      resultData[key] = convertInputTypeValue(temp_data, inputType, convertScale);
    }
  } else {
    const inputDirect = formMemo && formMemo[key] ? formMemo && formMemo[key].inputDirect : undefined;
    const target = typeof inputDirect === "string" ? inputDirect : inputDirect instanceof Object ? inputDirect.target : undefined;
    if (inputDirect && target) {
      if (!checkEmpty(data[target])) {
        if (
          formMemo &&
          formMemo[key] &&
          formMemo[key].selectMode !== undefined &&
          (formMemo[key].selectMode === "multiple" || formMemo[key].selectMode === "tags")
        ) {
          resultData[key] = [dv.input_direct];
          //Debug("checkEmpty", data[target]);
        } else {
          resultData[key] = dv.input_direct;
        }
        setInputDirectShow(form, inputDirect, true);
      } else {
        resultData[key] = undefined;
        setInputDirectShow(form, inputDirect, false);
      }
    } else {
      resultData[key] = undefined;
    }
  }
};
export const getMatchingSelectData = (
  form: FormInstance<any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  formMemo: Record<string, any> | undefined,
  field: string | undefined,
  exField?: string[],
  matching?: string[] | Record<string, string>,
) => {
  const selectData = runFormFunction(formFunction, field, "selectData");
  if (selectData.run) {
    const data = selectData.result;
    return getMatchingData(form, formMemo, data, exField, matching);
  } else {
    return {};
  }
};

export const setSelectChangeSync = (params: DataInputParams) => {
  const sync = params.selectChangeSync;
  if (sync) {
    if (typeof sync === "string") {
      const value = params.form?.getFieldValue(params.name);
      params.form?.setFieldValue(sync, value);
    } else if (sync instanceof Array) {
      const value = params.form?.getFieldValue(params.name);
      sync.forEach((item) => {
        params.form?.setFieldValue(item, value);
      });
    } else {
      const data = getValueListSelectData(params);
      Object.keys(sync).forEach((item) => {
        const key = sync[item];
        const value = data !== undefined ? data[key] : undefined;
        params.form?.setFieldValue(item, value);
      });
    }
  }
};

export const getSelectFilter = (
  filterRecord: Record<string, string | string[] | RegExp> | ((value: any, index: number, array: any[]) => unknown) | undefined,
  form: FormInstance<any> | undefined,
  formMemo: Record<string, any> | undefined,
  inputMode: string | undefined,
  values: any,
  join?: string,
  field?: boolean,
  fieldIndex?: number,
) => {
  if (filterRecord instanceof Function) {
    return filterRecord;
  } else if (filterRecord !== undefined) {
    // Debug("getSelectFilter filterRecord", filterRecord);
    const join_str = join ?? ",";
    return (item: any) => {
      const keys = Object.keys(filterRecord);
      return keys.every((key) => {
        const filter = filterRecord[key];
        const index_str = fieldIndex !== undefined ? "_" + fieldIndex : "";
        if (typeof filter === "string") {
          const filter_str = field
            ? convertFormMemoValue(form, formMemo, inputMode, values, filter + index_str, join_str)
            : filter + index_str;
          const regEx = new RegExp("(?:^|" + join_str + ")" + filter_str + "(?:" + join_str + "|$)", "g");
          const item_value = typeof item[key] === "string" ? item[key] : item[key] + "";
          // Debug("getSelectFilterRegEx", regEx, filter, filter_str, field, item[key], filterRecord);
          return !checkEmpty(filter_str) && !checkEmpty(item_value) && typeof item_value === "string"
            ? item_value.match(regEx)
              ? true
              : false
            : true;
        } else if (filter instanceof Array) {
          const filter_str = field
            ? filter
                .map((item) => {
                  return convertFormMemoValue(form, formMemo, inputMode, values, filter + index_str, join_str);
                })
                .filter((item) => {
                  return item && item.trim() !== "";
                })
            : filter;
          const regEx = new RegExp(
            filter_str
              .map((item) => {
                return "(?:^|" + join_str + ")" + item + "(?:" + join_str + "|$)";
              })
              .join("|"),
            "g",
          );
          const item_value = typeof item[key] === "string" ? item[key] : item[key] + "";

          // Debug("getSelectFilterRegEx", regEx, filter, field, item[key], filterRecord);
          return !checkEmpty(filter_str) && !checkEmpty(item_value) && typeof item_value === "string"
            ? item_value.match(regEx)
              ? true
              : false
            : true;
        } else if (filter instanceof RegExp) {
          return filter ? ((item[key] ?? "").match(filter) ? true : false) : true;
        } else {
          return filter;
        }
      });
    };
  }
};
const getSelectFilterRecord = (
  defaultField: string,
  selectFilter?:
    | string
    | string[]
    | RegExp
    | Record<string, string | string[] | RegExp>
    | ((value: any, index: number, array: any[]) => unknown)
    | undefined,
) => {
  const result: Record<string, string | RegExp | string[]> = {};
  if (selectFilter instanceof Function) {
    return selectFilter;
  } else if (typeof selectFilter === "string" || selectFilter instanceof RegExp || selectFilter instanceof Array) {
    result[defaultField] = selectFilter;
    return result;
  } else {
    return selectFilter;
  }
};

export const valueListFiltering = (params: DataInputParams, data: any[], filterField: string) => {
  if (params.selectFieldRequired) {
    const rf = typeof params.selectFieldRequired === "string" ? [params.selectFieldRequired] : params.selectFieldRequired;
    const item_next = params.index !== undefined ? "_" + params.index : "";

    const check = rf.some((item) => {
      const check_value = convertFormMemoValue(params.form, params.formMemo, params.inputMode, params.values, item + item_next);
      //  params.form?.getFieldInstance(item + item_next)
      //   ? params.form.getFieldValue(item + item_next)
      //   : params.values[item + item_next];
      // if (checkEmpty(check_value)) {
      //   Debug(
      //     "check empty : ",
      //     item + item_next,
      //     params.form?.getFieldValue(item + item_next),
      //     check_value,
      //     params.form?.getFieldInstance(item + item_next),
      //   );
      // }
      return checkEmpty(check_value);
    });
    if (check) {
      if (useValueListDebug) Debug("selectFieldRequired Block", params.name, filterField, item_next);
      return [];
    }
  }

  const join_str = params.valueJoin ?? ",";
  const filter = getSelectFilter(
    getSelectFilterRecord(filterField, params.selectFilter),
    params.form,
    params.formMemo,
    params.inputMode,
    params.values,
    join_str,
    false,
  );
  const fieldFilter = getSelectFilter(
    getSelectFilterRecord(filterField, params.selectFieldFilter),
    params.form,
    params.formMemo,
    params.inputMode,
    params.values,
    join_str,
    true,
    params.index,
  );
  const code_filter_list = filter && data instanceof Array ? data.filter(filter) : data;
  const code_field_filter_list =
    fieldFilter && code_filter_list && code_filter_list instanceof Array ? code_filter_list.filter(fieldFilter) : code_filter_list;

  const temp_data_value_list_arr = params.dataValueList
    ? typeof params.dataValueList === "string"
      ? [params.dataValueList]
      : params.dataValueList
    : undefined;

  if (temp_data_value_list_arr) {
    const data_values: any[] = [];
    const temp_data_value_list: any[] = [];
    const value_field = params.dataLabel?.value;
    temp_data_value_list_arr.forEach((target) => {
      const temp_list = params.values[target];
      if (temp_list && temp_list instanceof Array) {
        const temp_data_filter_list = filter ? temp_list.filter(filter) : temp_list;
        const temp_data_field_filter_list =
          fieldFilter && temp_data_filter_list ? temp_data_filter_list.filter(fieldFilter) : temp_data_filter_list;
        if (value_field) {
          const temp_filter_list = temp_data_field_filter_list.filter((item) => !data_values.includes(item[value_field]));
          data_values.push(...temp_filter_list.map((item) => item[value_field]));
          temp_data_value_list.push(...temp_filter_list);
        } else {
          temp_data_value_list.push(...temp_data_field_filter_list);
        }
      }
    });
    if (value_field) {
      // const data_values = code_field_filter_list.map((item) => item[value_field]);
      // return [...temp_data_field_filter_list.filter((item) => !data_values.includes(item[value_field])), ...code_field_filter_list];
      // Debug(temp_data_value_list);
      //return [...temp_data_field_filter_list, ...code_field_filter_list];
      if (!checkEmpty(code_field_filter_list) && code_field_filter_list instanceof Array) {
        return [...temp_data_value_list, ...code_field_filter_list.filter((item) => !data_values.includes(item[value_field]))];
      } else {
        return [...temp_data_value_list];
      }
    }
  }
  return code_field_filter_list;
};

export const getValueList = (
  loadingMode: loadingMode,
  params: DataInputParams,
  t?: TransitionType,
  reload?: boolean,
  loadAfter?: Function,
): DefaultOptionType[] | undefined => {
  //params.form;
  const input_direct_obj = !params.inputDirect || typeof params.inputDirect === "string" ? undefined : params.inputDirect;
  const input_direct_value = input_direct_obj?.value ?? dv.input_direct;
  const input_direct_label = input_direct_obj?.label ?? dv.input_direct;
  const input_direct_label_transition = input_direct_obj?.labelTransition ?? true;
  const input_direct_label_str =
    input_direct_obj?.labelStr ?? (typeof input_direct_label === "string" ? input_direct_label : dv.input_direct);
  const input_direct = {
    value: input_direct_obj?.value ?? dv.input_direct,
    label: (
      <span data-value={input_direct_value}>
        {typeof input_direct_label === "string" && input_direct_label_transition && t
          ? t(input_direct_label)
          : (input_direct_label ?? "Input Direct")}
      </span>
    ),
    label_str: input_direct_label_str && t && input_direct_label_transition ? t(input_direct_label_str) : "Input Direct",
  };
  if (params.valueList) {
    const temp_value_list =
      t && params.transition
        ? params.valueList.map((item) => {
            return { ...item, label: typeof item.label === "string" ? t(item.label) : item.label };
          })
        : params.valueList;
    if (params.inputDirect) {
      return [...temp_value_list, input_direct];
    } else {
      return temp_value_list;
    }
  } else {
    //코드 로딩 시작
    if (params.codeGroup && params.codeGroups && params.codeGroups[params.codeGroup]) {
      // Debug("params.codeGroups", params.codeGroups);
      const joinPrev = params.codeGroupJoinPrev ?? " - ";
      const joinNext = params.codeGroupJoinNext ?? "";
      const label_id = params.codeGroupLabel ?? (params.locale === enLocale ? "code_name" : "code_name_kr");

      const join_str = params.valueJoin ?? ",";
      const code_field_filter_list = valueListFiltering(params, params.codeGroups[params.codeGroup], "code_filter");

      if (params.formMemo && params.name) {
        if (!params.formMemo[params.name]) {
          params.formMemo[params.name] = {};
        }
        params.formMemo[params.name].data = { result: params.codeGroups[params.codeGroup] };
      }

      const result: DefaultOptionType[] = code_field_filter_list.map((item) => {
        const label = getCodeItemLabel(item, label_id, joinPrev, joinNext, params.locale);
        return { value: item.code_id, label: <span data-value={item.code_id}>{label}</span>, label_str: label };
      });
      setEmptyValue(params, result);
      setSelectTooltip(params, result);
      const loadFunction = () => {
        if (params.dataProp?.load && params.codeGroups && params.codeGroup) {
          if (useValueListDebug)
            Debug("getValueList codeGroup load : " + params.codeGroup + " - " + loadingMode, params, params.codeGroups[params.codeGroup]);
          params.dataProp?.load(params.codeGroups[params.codeGroup], getValueListSelectData(params), params.name, params.index);
        }
        if (loadAfter && params.codeGroups && params.codeGroup) {
          if (useValueListDebug)
            Debug(
              "getValueList codeGroup loadAfter : " + params.codeGroup + " - " + loadingMode,
              params,
              params.codeGroups[params.codeGroup],
            );
          loadAfter(params.codeGroups[params.codeGroup], getValueListSelectData(params), params.name, params.index);
        }
        if (params.selectChangeSync) {
          setSelectChangeSync(params);
        }
      };
      if (!params.loading) {
        if (loadingMode === "init" && params.initFunction?.current && useInitFunction) {
          if (useValueListDebug) Debug("getValueList codeGroup push useInitFunction : " + params.name);
          params.initFunction.current.push(() => {
            if (useValueListDebug) Debug("getValueList codeGroup load useInitFunction : " + params.name);
            loadFunction();
          });
        } else {
          loadFunction();
        }
      }

      if (params.inputDirect) {
        return [...result, input_direct];
      } else {
        return result;
      }
    } else if (params.dataUrl) {
      //url 로딩 시작
      const data_param: Record<string, any> = params.dataProp && params.dataProp.fixedParam ? { ...params.dataProp.fixedParam } : {};
      let fetch_check = true;

      if (params.dataProp) {
        if (params.dataProp.valueParam) {
          Object.keys(params.dataProp.valueParam).forEach((item) => {
            //item : 데이터의 필드, key 화면의 필드
            const key = params.dataProp?.valueParam ? params.dataProp.valueParam[item] : undefined;
            if (key) {
              const temp_value = convertFormMemoValue(params.form, params.formMemo, params.inputMode, params.values, key, params.valueJoin);
              if (!checkEmpty(temp_value)) {
                data_param[item] = temp_value;
              }
              if (checkEmpty(data_param[item]) && params.formMemo && params.formMemo[key] && params.formMemo[key].inputDirect) {
                const target = getInputDirectTarget(params.formMemo[key].inputDirect);
                if (
                  target &&
                  ((params.form?.getFieldInstance(target) && !checkEmpty(params.form.getFieldValue(target))) ||
                    !checkEmpty(params.values[target]))
                ) {
                  data_param[item] = dv.input_direct;
                }
              }
            }
            //Debug(key, data_param[key]);
          });
        }
        if (params.dataProp.requiredParam) {
          const data_param_keys = Object.keys(data_param);
          fetch_check = !params.dataProp.requiredParam.some((item) => {
            return !data_param_keys.includes(item);
          });
        }
      }

      if (fetch_check && params.dataProp?.check) {
        fetch_check = params.dataProp.check(params);
      }

      const temp_data_label = params.dataLabel ?? { value: "value", label: "label", label_str: "label_str" };
      //const temp_data_params = params.dataProp;
      //Debug(params.dataUrl, data_param, fetch_check);
      if (!fetch_check) {
        //Debug(params.dataUrl, data_param, fetch_check);
        setTimeout(() => {
          runFormFunction(params.formFunction, params.name, "setSelectLoading", false);
        }, 10);
      } else {
        const userAuth =
          params.dataProp?.userAuth !== undefined
            ? typeof params.dataProp.userAuth === "boolean"
              ? params.dataProp.userAuth
                ? params.userAuth
                : undefined
              : params.dataProp.userAuth
            : params.userAuth;
        const temp_user_auth = userAuth ? JSON.parse(JSON.stringify(userAuth)) : undefined;
        if (temp_user_auth) {
          Object.keys(temp_user_auth).forEach((auth) => {
            if (temp_user_auth[auth] && temp_user_auth[auth].usertype) {
              delete temp_user_auth[auth].usertype;
            }
          });
        }
        const data_param_str = data_param ? JSON.stringify(data_param) : "";
        const data_url_str =
          params.dataUrl + (data_param ? "|" + data_param_str : "") + (temp_user_auth ? "|" + JSON.stringify(temp_user_auth) : "");
        const now = new Date();

        let temp_memo_data = undefined;
        if (params.formMemo && params.name) {
          if (!params.formMemo[params.name]) {
            params.formMemo[params.name] = {};
          }
          if (params.formMemo[params.name].data === undefined) {
            params.formMemo[params.name].data = { loading: false };
          }
          temp_memo_data = params.formMemo[params.name].data;
          //if (temp_memo_data) Debug(temp_memo_data);
        }
        const check_time_diff = params.dataProp?.term ?? Number(process.env.NEXT_PUBLIC_CACHE_TERM_LOW);
        const check_time = new Date(now.getTime() - check_time_diff).valueOf();
        if (
          !reload &&
          temp_memo_data &&
          temp_memo_data.url === data_url_str &&
          temp_memo_data.user_seq === params.userSeq &&
          temp_memo_data.access_at &&
          temp_memo_data.access_at.valueOf() >= check_time
        ) {
          if (temp_memo_data.result && temp_memo_data.result instanceof Array) {
            const result = getDataValueList(valueListFiltering(params, temp_memo_data.result, "filter"), temp_data_label);
            // Debug("valueList not change loadAfter", params.name); //result
            setEmptyValue(params, result);
            setSelectTooltip(params, result);
            const loadFunction = () => {
              if (params.dataProp?.load) {
                if (useValueListDebug) Debug("getValueList url load : " + params.name + " - " + loadingMode, params);
                params.dataProp?.load(temp_memo_data.result, getValueListSelectData(params), params.name, params.index, false);
              }
              if (loadAfter) {
                if (useValueListDebug) Debug("getValueList url loadAfter : " + params.name + " - " + loadingMode, params);
                loadAfter(temp_memo_data.result, getValueListSelectData(params), params.name, params.index);
              }
              if (params.selectChangeSync) {
                setSelectChangeSync(params);
              }
            };
            if (!params.loading) {
              if (loadingMode === "init" && params.initFunction?.current && useInitFunction) {
                if (useValueListDebug) Debug("getValueList url push useInitFunction : " + params.name);
                params.initFunction.current.push(() => {
                  if (useValueListDebug) Debug("getValueList url load useInitFunction : " + params.name);
                  loadFunction();
                });
              } else {
                loadFunction();
              }
            }
            if (params.inputDirect) {
              return [...result, input_direct];
            } else {
              return result;
            }
          }
        } else {
          //console.log("start code load check", params.dataUrl, data_param, fetch_check, temp_memo_data);
          //값 변경시 그리고 로딩중이지 않을때 로딩 시작함
          if (!temp_memo_data.loading) {
            //Debug("start loading", temp_memo_data);
            if (params.formMemo && params.name) params.formMemo[params.name].data.loading = true;
            // Debug(temp_memo_data);
            // const setLoading =
            //   params.formFunction && params.name && params.formFunction[params.name]
            //     ? params.formFunction[params.name]["setSelectLoading"]
            //     : undefined;
            //if (setLoading) setLoading(true);

            setTimeout(() => {
              runFormFunction(params.formFunction, params.name, "setSelectLoading", true);
            }, 10);

            if (params.dataProp?.start) {
              params.dataProp.start();
            }
            getDBData(
              params.name,
              params.userSeq,
              temp_user_auth,
              params.locale,
              params.dataUrl,
              data_param,
              params.dataProp,
              data_url_str,
              now,
              (put_result: any) => {
                if (useValueListDebug) Debug("getDBData", params.name, params.formMemo, put_result);
                if (params.formMemo && params.name) {
                  if (!params.formMemo[params.name]) {
                    params.formMemo[params.name] = {};
                  }
                  params.formMemo[params.name].data = JSON.parse(JSON.stringify(put_result));
                }
                const value_list = getDataValueList(valueListFiltering(params, put_result.result, "filter"), temp_data_label);
                const setValueList = params.setValueList && params.name ? params.setValueList[params.name] : undefined;
                if (setValueList) {
                  if (useValueListDebug)
                    Debug(
                      "value_list : " + params.name,
                      [...value_list, input_direct],
                      params.value,
                      params.form?.getFieldValue(params.name),
                      put_result.result,
                    );
                  if (params.inputDirect) {
                    setValueList([...value_list, input_direct]);
                  } else {
                    setValueList(value_list);
                  }
                }
                setEmptyValue(params, value_list);
                setSelectTooltip(params, value_list);
                const loadFunction = () => {
                  if (params.dataProp?.load) {
                    if (useValueListDebug) Debug("getValueList dbdata load : " + params.name + " - " + loadingMode, params, value_list);
                    params.dataProp?.load(put_result.result, getValueListSelectData(params), params.name, params.index, true);
                  }
                  if (loadAfter) {
                    if (useValueListDebug) Debug("getValueList dbdata loadAfter", params.name + " - " + loadingMode, params, value_list);
                    loadAfter(put_result.result, getValueListSelectData(params), params.name, params.index);
                  }
                  if (params.selectChangeSync) {
                    setSelectChangeSync(params);
                  }
                  if (params.selectWithLoad) {
                    const selectWithLoad = typeof params.selectWithLoad === "string" ? [params.selectWithLoad] : params.selectWithLoad;
                    if (useValueListDebug) Debug("selectWithLoad : " + params.name, selectWithLoad);
                    selectWithLoad.forEach((item) => {
                      if (params.formMemo && params.formMemo[item] && params.formMemo[item].data) {
                        delete params.formMemo[item].data;
                      }
                      const tempFunction =
                        params.formFunction && params.formFunction[item] ? params.formFunction[item]["changeLoad"] : undefined;
                      if (tempFunction) {
                        tempFunction();
                      }
                    });
                  }
                  setTimeout(
                    () => {
                      runFormFunction(params.formFunction, params.name, "setSelectLoading", false);
                      //if (setLoading) setLoading(false);
                    },
                    reload ? 1000 : 100,
                  );
                };
                if (!params.loading) {
                  if (loadingMode === "init" && params.initFunction?.current && useInitFunction) {
                    if (useValueListDebug) Debug("getValueList url dbdata push useInitFunction : " + params.name);
                    params.initFunction.current.push(() => {
                      if (useValueListDebug) Debug("getValueList url dbdata load useInitFunction : " + params.name);
                      loadFunction();
                    });
                  } else {
                    if (useValueListDebug) Debug("getValueList url dbdata push loadFunction : " + params.name, put_result);
                    loadFunction();
                  }
                }
              },
              params.selectWithFields && typeof params.name === "string" && params.selectWithFields.includes(params.name),
              params.dataProp?.firstReload ? true : reload,
            );
          }
        }
      }
      if (useValueListDebug) Debug("임시 빈값 집어 넣기 : " + fetch_check);
      if (params.inputDirect) {
        return [input_direct];
      } else {
        return undefined;
      }
    } else {
      if (params.dataValueList) {
        if (params.inputMode !== "view" || Object.keys(params.values).length > 0) {
          const loadFunction = () => {
            const temp_data_label = params.dataLabel ?? { value: "value", label: "label", label_str: "label_str" };
            const value_list = valueListFiltering(params, [], "filter");
            const result = getDataValueList(value_list, temp_data_label);
            setEmptyValue(params, result);
            setSelectTooltip(params, result);

            const setValueList = params.setValueList && params.name ? params.setValueList[params.name] : undefined;
            // if (useValueListDebug) Debug("dataValueList", [...value_list, input_direct], params.form?.getFieldValue(params.name));
            if (setValueList) {
              if (params.inputDirect) {
                setValueList([...result, input_direct]);
              } else {
                setValueList(result);
              }
            }
            if (params.dataProp?.load) {
              if (useValueListDebug) Debug("getValueList dataValueList load : " + params.name + " - " + loadingMode, params);
              params.dataProp?.load(value_list, getValueListSelectData(params), params.name, params.index, true);
            }
            if (loadAfter) {
              if (useValueListDebug) Debug("getValueList dataValueList loadAfter : " + params.name + " - " + loadingMode, params);
              loadAfter(value_list, getValueListSelectData(params), params.name, params.index);
            }
            if (params.selectChangeSync) {
              setSelectChangeSync(params);
            }
            if (params.selectWithLoad) {
              const selectWithLoad = typeof params.selectWithLoad === "string" ? [params.selectWithLoad] : params.selectWithLoad;
              selectWithLoad.forEach((item) => {
                if (params.formMemo && params.formMemo[item] && params.formMemo[item].data) {
                  delete params.formMemo[item].data;
                }
                const tempFunction = params.formFunction && params.formFunction[item] ? params.formFunction[item]["changeLoad"] : undefined;
                if (tempFunction) {
                  tempFunction();
                }
              });
            }
          };
          if (loadingMode === "init" && params.initFunction?.current && useInitFunction) {
            if (useValueListDebug) Debug("getValueList dataValueList push useInitFunction : " + params.name, params.values);
            params.initFunction.current.push(() => {
              if (useValueListDebug) Debug("getValueList dataValueList load useInitFunction : " + params.name, params.values);
              setTimeout(() => {
                loadFunction();
              }, dv.setTimeoutShort);
            });
          } else {
            setTimeout(() => {
              loadFunction();
            }, dv.setTimeoutShort);
          }
        }
        if (params.inputDirect) {
          return [input_direct];
        } else {
          return undefined;
        }
      } else {
        if (params.inputDirect) {
          return [input_direct];
        } else {
          return undefined;
        }
      }
    }
  }
};
export const getTransitionValueLabel = (value: any, valueList?: DefaultOptionType[], t?: TransitionType, transition?: boolean) => {
  const temp_value = getValueLabel(value, valueList);
  return temp_value && typeof temp_value === "string" && t && transition ? t(temp_value) : temp_value;
};

export const getValueLabel = (value: any, valueList?: DefaultOptionType[]) => {
  if (valueList) {
    const [defaultValueObj] = valueList.filter((item) => item.value === value);
    return defaultValueObj ? defaultValueObj.label : undefined;
  } else {
    return undefined;
  }
};
export const getLabelInputName = (params: DataInputParams, index?: boolean) => {
  return params.labelInput
    ? typeof params.labelInput.fieldId === "string"
      ? params.labelInput.fieldId + (params.index !== undefined && (index ?? true) ? "_" + params.index : "")
      : typeof params.label === "string"
        ? params.label + (params.index !== undefined && (index ?? true) ? "_" + params.index : "")
        : "label_" +
          (params.subListName !== undefined
            ? params.subListName + (params.index !== undefined && (index ?? true) ? "_" + params.index : "")
            : params.name)
    : undefined;
};
export const getColsFields = (dataCols?: DataCols) => {
  const fields: Record<string, DataInputCommonParams> = {};
  if (dataCols) {
    if (!(dataCols instanceof Array)) {
      const col_keys = Object.keys(dataCols);
      col_keys.forEach((col_key) => {
        const col = dataCols[col_key];
        const subListTarget = getSubListTarget(col, col_key);
        const col_input: DataInputParams = { ...col, fieldId: col.fieldId ?? col_key, name: col_key, values: undefined, subValues: {} };
        if (col.labelInput) {
          const labelName = getLabelInputName(col_input);
          if (labelName) {
            fields[labelName] = col.labelInput;
            getParamsFieldsCommon(col.labelInput, fields);
          }
        }
        const temp_fields = getParamFields(col_input);
        const temp_keys = Object.keys(temp_fields);
        temp_keys.forEach((temp_key) => {
          if (subListTarget) {
            fields[temp_key] = { ...temp_fields[temp_key], subListTarget: subListTarget };
          } else {
            fields[temp_key] = temp_fields[temp_key];
          }
        });
      });
    } else {
      dataCols.forEach((col) => {
        Debug(col);
        if (typeof col === "string") {
          fields[col] = {};
        } else {
          const col_input: DataInputParams = { ...col, values: undefined, subValues: {} };
          const temp_fields = getParamFields(col_input);
          const temp_keys = Object.keys(temp_fields);
          temp_keys.forEach((temp_key) => {
            fields[temp_key] = temp_fields[temp_key];
          });
          if (col.labelInput) {
            const labelName = getLabelInputName(col_input);
            if (labelName) {
              fields[labelName] = col.labelInput;
              getParamsFieldsCommon(col.labelInput, fields);
            }
          }
        }
      });
    }
  }
  return fields;
};

export const getColsGroups = (dataCols?: DataCols) => {
  const groups: string[] = [];
  if (dataCols) {
    if (!(dataCols instanceof Array)) {
      const col_keys = Object.keys(dataCols);
      col_keys.forEach((col_key) => {
        const col = dataCols[col_key];
        if (col.codeGroup) {
          groups.push(col.codeGroup);
        }
        const col_input: DataInputParams = { ...col, values: undefined, subValues: {} };
        const fields = getParamFields(col_input);
        if (fields) {
          const fields_key = Object.keys(fields);
          fields_key.forEach((key) => {
            const codeGroup = fields[key].codeGroup;
            if (codeGroup && !groups.includes(codeGroup)) {
              groups.push(codeGroup);
            }
          });
        }
      });
    } else {
      dataCols.forEach((col) => {
        if (typeof col !== "string") {
          if (col.codeGroup && !groups.includes(col.codeGroup)) {
            groups.push(col.codeGroup);
          }
        }
      });
    }
  }
  if (groups.length > 0) {
    return groups;
  } else {
    return undefined;
  }
};

export const getFormDateDiff = (
  form: FormInstance<any> | undefined,
  start?: string,
  end?: string,
  add?: number,
  diffType?: "day" | "week" | "quarter" | "month" | "year" | "hour" | "minute" | "second" | "millisecond",
) => {
  if (form && start && end) {
    const startDate = form.getFieldValue(start);
    const endDate = form.getFieldValue(end);
    return getDateDiff(startDate, endDate, add, diffType);
  }
  return undefined;
};

export const getDateDiff = (
  startDate: any,
  endDate: any,
  add?: number,
  diffType?: "day" | "week" | "quarter" | "month" | "year" | "hour" | "minute" | "second" | "millisecond",
) => {
  if (startDate && endDate) {
    const result = diffType ? dayjs(endDate).diff(dayjs(startDate), diffType) : dayjs(endDate).diff(dayjs(startDate), "day");
    if (result && add !== undefined) {
      return result + add;
    } else {
      return result;
    }
  }
  return undefined;
};
export const convertTempFtoC = (value: number, round?: number) => {
  const result = ((value - 32) * 5) / 9;
  return round !== undefined ? Math.round(result * round) / round : result;
};
export const convertTempCtoF = (value: number, round?: number) => {
  const result = (value * 9) / 5 + 32;
  return round !== undefined ? Math.round(result * round) / round : result;
};
export function UnitConvertor(params: DataInputParams) {
  if (params.formMemo && params.name && params.formMemo[params.name] && params.unit) {
    const isInstance = params.form?.getFieldInstance(params.name) ? true : false;
    const temp_memo = params.formMemo[params.name];
    const beforeUnit = isInstance ? temp_memo.beforeUnit : params.unit;
    const convertUnit = temp_memo.convertUnit;
    const beforeValue: number | undefined = isInstance ? params.form?.getFieldValue(params.name) : params.value;
    const beforeStep =
      temp_memo.beforeStep !== undefined ? temp_memo.beforeStep : (params.step ?? (params.scale ? 1 / params.scale : undefined));
    let convertValue: number | undefined = undefined;
    let convertStep: number | undefined = undefined;
    if (beforeUnit && convertUnit && beforeValue !== null && beforeValue !== undefined) {
      //Debug(beforeUnit, convertUnit, beforeValue);
      switch (beforeUnit) {
        //온도
        case "°C":
          switch (convertUnit) {
            case "°F":
              convertValue = convertTempCtoF(beforeValue);
              break;
          }
          break;
        case "°F":
          switch (convertUnit) {
            case "°C":
              convertValue = convertTempFtoC(beforeValue);
              break;
          }
          break;
        //무게
        case "g":
          switch (convertUnit) {
            // case "g":
            //   convertValue = beforeValue;
            //   break;
            case "Kg":
              convertValue = beforeValue / 1000;
              if (beforeStep) {
                convertStep = beforeStep / 1000;
              }
              break;
            case "t":
              convertValue = beforeValue / 1000000;
              if (beforeStep) {
                convertStep = beforeStep / 1000000;
              }
              break;
            case "oz":
              convertValue = beforeValue / 28.35;
              if (beforeStep) {
                convertStep = beforeStep / 100;
              }
              break;
            case "lb":
            case "lbs":
              convertValue = beforeValue / 453.6;
              if (beforeStep) {
                convertStep = beforeStep / 1000;
              }
              break;
          }
          break;
        case "Kg":
          switch (convertUnit) {
            case "g":
              convertValue = beforeValue * 1000;
              if (beforeStep) {
                convertStep = beforeStep * 1000;
              }
              break;
            // case "Kg":
            //   convertValue = beforeValue / 1000;
            //   if (beforeStep) {
            //     convertStep = beforeStep / 1000;
            //   }
            //   break;
            case "t":
              convertValue = beforeValue / 1000;
              if (beforeStep) {
                convertStep = beforeStep / 1000;
              }
              break;
            case "oz":
              convertValue = beforeValue / 0.02835;
              if (beforeStep) {
                convertStep = beforeStep / 10;
              }
              break;
            case "lb":
            case "lbs":
              convertValue = beforeValue / 0.4536;
              if (beforeStep) {
                //convertStep = beforeStep;
              }
              break;
          }
          break;
        case "oz":
          switch (convertUnit) {
            case "g":
              convertValue = beforeValue * 28.35;
              if (beforeStep) {
                convertStep = beforeStep * 10;
              }
              break;
            case "Kg":
              convertValue = beforeValue * 0.02835;
              if (beforeStep) {
                convertStep = beforeStep / 100;
              }
              break;
            case "t":
              convertValue = beforeValue * 0.00002835;
              if (beforeStep) {
                convertStep = beforeStep / 100000;
              }
              break;
            // case "oz":
            // convertValue = beforeValue / 0.02835;
            // if (beforeStep) {
            //   convertStep = beforeStep / 10;
            // }
            // break;
            case "lb":
            case "lbs":
              convertValue = beforeValue / 16;
              if (beforeStep) {
                convertStep = beforeStep / 10;
              }
              break;
          }
          break;
        case "lb":
        case "lbs":
          switch (convertUnit) {
            case "g":
              convertValue = beforeValue * 453.6;
              if (beforeStep) {
                convertStep = beforeStep * 100;
              }
              break;
            case "Kg":
              convertValue = beforeValue * 0.4536;
              if (beforeStep) {
                convertStep = beforeStep / 10;
              }
              break;
            case "t":
              convertValue = beforeValue * 0.0004536;
              if (beforeStep) {
                convertStep = beforeStep / 10000;
              }
              break;
            case "oz":
              convertValue = beforeValue / 0.02835;
              if (beforeStep) {
                convertStep = beforeStep / 10;
              }
              break;
            // case "lb":
            // case "lbs":
            //   convertValue = beforeValue / 16;
            //   if (beforeStep) {
            //     convertStep = beforeStep / 10;
            //   }
            //   break;
          }
          break;
        case "t":
          switch (convertUnit) {
            case "g":
              convertValue = beforeValue * 1000000;
              if (beforeStep) {
                convertStep = beforeStep * 1000000;
              }
              break;
            case "Kg":
              convertValue = beforeValue * 1000;
              if (beforeStep) {
                convertStep = beforeStep * 1000;
              }
              break;
            case "oz":
              convertValue = beforeValue / 0.00002835;
              if (beforeStep) {
                convertStep = beforeStep / 100000;
              }
              break;
            case "lb":
            case "lbs":
              convertValue = beforeValue / 0.4536;
              if (beforeStep) {
                convertStep = beforeStep / 100;
              }
              break;
          }
          break;
        default:
          break;
      }
    }
    if (isInstance && convertStep !== null && convertStep !== undefined) {
    }
    if (convertValue !== null && convertValue !== undefined) {
      if (isInstance) {
        params.form?.setFieldValue(params.name, convertValue);
      } else {
      }
    }
  }
}
const multipleValueMode = [
  "quarterRange",
  "monthRange",
  "weekRange",
  "dateRange",
  "datetimeRange",
  "yearMulti",
  "quarterMulti",
  "monthMulti",
  "weekMulti",
  "dateMulti",
  "yearRange",
  "timeRange",
];
const checkMultipleValueMode = (params: DataInputParams): boolean => {
  return (
    params.valueType !== "array" &&
    ((params.inputType && multipleValueMode.includes(params.inputType)) ||
      ((params.inputType === "select" || params.inputType === "selectSearch") &&
        (params.selectProp?.mode === "tags" || params.selectProp?.mode === "multiple")) ||
      (params.inputType === "checkbox" && params.checkboxOption !== undefined) ||
      params.valueType === "stringArray")
  );
};

export const getInputDirectTarget = (inputDirect: any) => {
  return inputDirect ? (typeof inputDirect === "string" ? inputDirect : inputDirect.target) : undefined;
};
export const getInputDirectValue = (params: DataInputParams) => {
  const target = getInputDirectTarget(params.inputDirect);
  return target ? checkEmptyValue(params.values[target]) : undefined;
};
export const getMultiValue = (params: DataInputParams, value?: any): any => {
  const input_direct_value = getInputDirectValue(params);
  const check_multi = checkMultipleValueMode(params);
  if (params.name === "roasting_check_term") {
    Debug("getMultiValue", params.name, value, params.values, params);
  }
  if (check_multi) {
    if (params.fieldIds && !checkEmpty(params.fieldIds) && params.values) {
      const temp_value = params.fieldIds.map((item) => params.values[item]);
      if (input_direct_value !== undefined) {
        if (params.inputMode === "view") {
          return [...temp_value, input_direct_value];
        } else {
          return [...temp_value, dv.input_direct];
        }
      } else {
        return temp_value;
      }
    } else if (typeof value === "string") {
      const join_str = params.valueJoin ?? ",";
      if (value.includes(join_str)) {
        const value_arr: (string | number)[] =
          params.selectPropOption?.multiValueNumber || params.valueType === "number"
            ? value.split(join_str).map((temp) => Number(temp))
            : value.split(join_str);
        if (input_direct_value !== undefined) {
          if (params.inputMode === "view") {
            value_arr.push(input_direct_value);
          } else {
            value_arr.push(dv.input_direct);
          }
        }
        if (checkEmpty(value_arr)) {
          return undefined;
        } else {
          return value_arr;
        }
      } else {
        const n_value = params.selectPropOption?.multiValueNumber || params.valueType === "number" ? Number(value) : value;
        if (input_direct_value !== undefined) {
          if (params.inputMode === "view") {
            return [n_value, input_direct_value];
          } else {
            return [n_value, dv.input_direct];
          }
        } else {
          if (checkEmpty(value)) {
            return undefined;
          } else {
            return [n_value];
          }
        }
      }
    } else if (value instanceof Array) {
      if (input_direct_value !== undefined) {
        if (params.inputMode === "view") {
          return [...value, input_direct_value];
        } else {
          return [...value, dv.input_direct];
        }
      } else {
        return value;
      }
    } else {
      if (value !== undefined && !checkEmpty(value)) {
        if (input_direct_value !== undefined) {
          if (value instanceof Array) {
            if (params.inputMode === "view") {
              return [...value, input_direct_value];
            } else {
              return [...value, dv.input_direct];
            }
          } else {
            if (params.inputMode === "view") {
              return [value, input_direct_value];
            } else {
              return [value, dv.input_direct];
            }
          }
        } else {
          if (value instanceof Array) {
            return value;
          } else {
            return [value];
          }
        }
      } else {
        if (params.name === "code_filter") {
          Debug("else empty", params, check_multi, value);
        }
        if (input_direct_value !== undefined) {
          if (params.inputMode === "view") {
            return [input_direct_value];
          } else {
            return [dv.input_direct];
          }
        } else {
          if (checkEmpty(value)) {
          } else if (value instanceof Array) {
            return value;
          } else {
            return [value];
          }
        }
      }
    }
  }
  const return_value =
    params.inputMode === "view"
      ? ((params.index === undefined && typeof params.fieldId === "string" ? params.values[params.fieldId] : value) ?? input_direct_value)
      : ((params.index === undefined && typeof params.fieldId === "string" ? params.values[params.fieldId] : value) ??
        (input_direct_value !== undefined ? dv.input_direct : undefined));
  const result = checkEmpty(return_value) ? undefined : check_multi && !(return_value instanceof Array) ? [return_value] : return_value;
  return result;
  // if (params.inputMode === "view") {
  //   return (params.index === undefined && typeof params.fieldId === "string" ? params.values[params.fieldId] : value) ?? input_direct_value; // !== undefined ? dv.input_direct : undefined;
  // } else {
  //   return (
  //     (params.index === undefined && typeof params.fieldId === "string" ? params.values[params.fieldId] : value) ??
  //     (input_direct_value !== undefined ? dv.input_direct : undefined)
  //   );
  // }
};
export const getMultiValueStr = (params: DataInputParams, value?: any) => {
  if (value) {
    if (checkMultipleValueMode(params) && value instanceof Array) {
      const join_str = params.valueJoin ?? ",";
      return value.join(join_str);
    }
  }
  return value;
};
const checkValuesNull = (params: DataInputParams, condition?: "Null" | "NullOr") => {
  const c = condition === "NullOr" ? "notNullAnd" : "notNull";
  return !checkValuesNotNull(params, c);
};
const checkValuesNotNull = (params: DataInputParams, condition?: "notNull" | "notNullAnd") => {
  if (params.displayCheckIds && !checkEmpty(params.displayCheckIds)) {
    if (condition === "notNullAnd") {
      return !params.displayCheckIds.some((key: any) => {
        const check_value = params.values[key];
        return check_value === null || check_value === undefined;
      });
    } else {
      return !params.displayCheckIds.every((key: any) => {
        const check_value = params.values[key];
        return check_value === null || check_value === undefined;
      });
    }
  } else if (params.index !== undefined && params.displayCheckIndexIds && !checkEmpty(params.displayCheckIndexIds)) {
    const subListTarget = params.subListTarget && params.values[params.subListTarget] ? params.values[params.subListTarget] : undefined;
    if (condition === "notNullAnd") {
      return !params.displayCheckIndexIds.some((key: any) => {
        const check_value =
          subListTarget && params.index !== undefined && params.subListName
            ? subListTarget[params.index][key]
            : params.index !== undefined
              ? params.values[key + "_" + params.index]
              : params.values[key];
        return check_value === null || check_value === undefined;
      });
    } else {
      return !params.displayCheckIndexIds.every((key: any) => {
        const check_value =
          subListTarget && params.index !== undefined && params.subListName
            ? subListTarget[params.index][key]
            : params.index !== undefined
              ? params.values[key + "_" + params.index]
              : params.values[key];
        return check_value === null || check_value === undefined;
      });
    }
  } else {
    const direnct_target_name = params.inputDirect
      ? typeof params.inputDirect === "string"
        ? params.inputDirect
        : params.inputDirect?.target
      : undefined;
    if (direnct_target_name) {
      return !checkEmpty(params.value) || !checkEmpty(params.values[direnct_target_name]);
    } else {
      return !checkEmpty(params.value);
    }
  }
};
const checkValuesBoolean = (params: DataInputParams, condition: "true" | "false") => {
  const check = condition === "true" ? 1 : 0;
  if (params.displayCheckIds && !checkEmpty(params.displayCheckIds)) {
    return !params.displayCheckIds.every((key: any) => {
      // Debug("checkValuesBoolean", key, check);
      return params.values[key] !== check;
    });
  } else if (params.index !== undefined && params.displayCheckIndexIds && !checkEmpty(params.displayCheckIndexIds)) {
    return !params.displayCheckIndexIds.every((key: any) => {
      // Debug("checkValuesBoolean", key, check);
      return params.values[key + "_" + params.index] !== check;
    });
  } else {
    return params.value !== undefined ? params.value === check : true;
  }
};
export const checkDisabled = (params: DataInputParams) => {
  if (params.inputMode === "view" && (params.readInputDisabled ?? true) ? true : params.disabled) {
    return true;
  } else {
    const checkUserType = params.enabledUserType;
    if (checkUserType) {
      if (params.userType) {
        if (
          !params.userType.some((item) => {
            return checkUserType.includes(item);
          })
        ) {
          return true;
        }
      } else {
        return true;
      }
    }
    const checkUserAuth = params.enabledUserAuth;
    if (checkUserAuth) {
      const userAuth = params.userAuth;
      if (userAuth) {
        // Debug(checkUserAuth, userAuth);
        const keys = Object.keys(checkUserAuth);
        return !keys.every((key) => {
          if (!userAuth[key] || !checkUserAuth[key].includes(userAuth[key].usertype)) {
            // Debug("checkDisabled", key, false, userAuth[key].usertype);
            return false;
          } else {
            return true;
          }
        });
      } else {
        return true;
      }
    }
    return false;
  }
};
export const checkDisplay = (params: DataInputParams, show?: boolean) => {
  const dataGuideType = params.dataGuideType ?? "FULL";
  const guide = params.guide ?? false;
  if (guide !== false) {
    switch (dataGuideType) {
      case "NONE":
        return false;
      default:
        if (guide !== "ALL" && guide !== dataGuideType) {
          return false;
        }
    }
  }
  const checkUserType = params.checkUserType;
  if (checkUserType) {
    if (params.userType) {
      if (
        !params.userType.some((item) => {
          return checkUserType.includes(item);
        })
      ) {
        return false;
      }
    } else {
      return false;
    }
  }
  const checkUserAuth = params.checkUserAuth;
  if (checkUserAuth) {
    const userAuth = params.userAuth;
    if (userAuth) {
      // Debug(checkUserAuth, userAuth);
      const keys = Object.keys(checkUserAuth);
      return keys.every((key) => {
        if (!userAuth[key] || !checkUserAuth[key].includes(userAuth[key].usertype)) {
          // Debug("checkDisplay", key, false, userAuth[key].usertype);
          return false;
        } else {
          return true;
        }
      });
    } else {
      return false;
    }
  }
  return checkDisplayCommon(params);
};

export const checkDisplayCommon = (params: DataInputParams, show?: boolean) => {
  const check = show ? params.show : params.display;
  if (check === "change") {
    return false;
  } else if (check === "Null" || check === "NullOr") {
    return checkValuesNull(params, check);
  } else if (check === "notNull" || check === "notNullAnd") {
    return checkValuesNotNull(params, check);
  } else if (check === "true" || check === "false") {
    return checkValuesBoolean(params, check);
  } else if (check instanceof Function) {
    return check();
  } else if (check instanceof Array) {
    //let display = true;
    const display = check.every((obj) => {
      if (obj === "Null" || obj === "NullOr") {
        return checkValuesNull(params, obj);
      } else if (obj === "notNull" || obj === "notNullAnd") {
        return checkValuesNotNull(params, obj);
      } else if (obj === "true" || obj === "false") {
        return checkValuesBoolean(params, obj);
      } else {
        return Object.keys(obj).every((key) => {
          const condition = obj[key];
          const check_value = params.values[key];
          const naver_value: never = check_value as never;
          if (check_value instanceof Array) {
            if (typeof condition === "string" || typeof condition === "number" || typeof condition === "boolean") {
              return check_value.includes(condition);
            } else if (condition instanceof Array) {
              return check_value.some((item) => condition.includes(item as never));
            } else if (condition instanceof Object) {
              const value = condition.value;
              const check =
                value instanceof Array ? check_value.some((item) => value.includes(item as never)) : check_value.includes(value);
              return condition.equals ? check : !check;
            } else {
              return true;
            }
          } else {
            if (typeof condition === "string" || typeof condition === "number" || typeof condition === "boolean") {
              return check_value === condition;
            } else if (condition instanceof Array) {
              return condition.includes(naver_value);
            } else if (condition instanceof Object) {
              const check = condition.value instanceof Array ? condition.value.includes(naver_value) : check_value === condition.value;
              return condition.equals ? check : !check;
            } else {
              return true;
            }
          }
        });
      }
    });
    return display;
  } else if (check instanceof Object) {
    const obj = check as Record<
      string,
      boolean | string | number | (string | number | null)[] | { value: string | number | (string | number | null)[]; equals: boolean }
    >;
    if (obj) {
      return Object.keys(obj).every((key) => {
        const condition = obj[key];
        const check_value = params.values[key];
        const naver_value: never = check_value as never;
        if (check_value instanceof Array) {
          if (typeof condition === "string" || typeof condition === "number" || typeof condition === "boolean") {
            return check_value.includes(condition);
          } else if (condition instanceof Array) {
            return check_value.some((item) => condition.includes(item as never));
          } else if (condition instanceof Object) {
            const value = condition.value;
            const check = value instanceof Array ? check_value.some((item) => value.includes(item as never)) : check_value.includes(value);
            return condition.equals ? check : !check;
          } else {
            return true;
          }
        } else {
          if (typeof condition === "string" || typeof condition === "number" || typeof condition === "boolean") {
            return check_value === condition;
          } else if (condition instanceof Array) {
            return condition.includes(naver_value);
          } else if (condition instanceof Object) {
            const check = condition.value instanceof Array ? condition.value.includes(naver_value) : check_value === condition.value;
            return condition.equals ? check : !check;
          } else {
            return true;
          }
        }
      });
    } else {
      return true;
    }
  } else {
    return check ?? true;
  }
};

export const checkListButtonDisplay = (listButton: ListClickButton | undefined, values: any) => {
  return listButton && listButton.display !== undefined
    ? checkDisplayCommon({
        value: listButton.field ? values[listButton.field] : undefined,
        values: values,
        display: listButton.display,
        displayCheckIds: listButton.displayCheckIds,
      })
    : true;
};
export const checkInputDirect = (params: DataInputParams, focus?: boolean) => {
  if (params.inputDirect) {
    const obj = { target: "", query: "", autoFocus: true };
    if (typeof params.inputDirect == "string") {
      obj.target = params.inputDirect;
      obj.query = "#" + obj.target;
    } else {
      obj.target = params.inputDirect.target;
      obj.query = params.inputDirect.query ?? "#" + obj.target;
      obj.autoFocus = params.inputDirect.autoFocus ?? true;
    }
    if (params.form) {
      const target = params.form.getFieldInstance(obj.target);
      const hiddenTarget = document.querySelectorAll(obj.query);
      const e = target ? params.form.getFieldValue(params.name) : params.value;
      if ((typeof e === "string" && e === dv.input_direct) || (e instanceof Array && e.includes(dv.input_direct))) {
        if (target) {
          target.nativeElement.classList.remove("hidden");
          if ((focus ?? true) && obj.autoFocus) {
            setTimeout(() => {
              target.focus();
            }, 100);
          }
        }
        if (hiddenTarget) {
          hiddenTarget.forEach((item) => {
            item.classList.remove("hidden");
          });
        }
      } else {
        if (target && target.nativeElement) {
          //Debug(target);
          target.nativeElement.classList.add("hidden");
        }
        //Debug(obj, hiddenTarget);
        if (hiddenTarget) {
          hiddenTarget.forEach((item) => {
            item.classList.add("hidden");
          });
        }
      }
    }
  }
};
export const setSubListDisplay = (
  formFunction: Record<string, Record<string, Function>>,
  subList: string,
  hiddenList: string | string[],
  hiddenIndexList: string | string[],
  showList: string | string[],
  showIndexList: string | string[],
) => {
  const tf = formFunction[subList];
  if (tf && tf.getCount) {
    const count = tf.getCount();
    for (let i = 0; i < count; i++) {
      (hiddenIndexList instanceof Array ? hiddenIndexList : [hiddenIndexList]).map((item) => {
        setFormDisplay(formFunction, item + "_" + i, false);
      });
      (showIndexList instanceof Array ? showIndexList : [showIndexList]).map((item) => {
        setFormDisplay(formFunction, item + "_" + i, true);
      });
    }
    (hiddenList instanceof Array ? hiddenList : [hiddenList]).map((item) => {
      setFormDisplay(formFunction, item, false);
    });
    (showList instanceof Array ? showList : [showList]).map((item) => {
      setFormDisplay(formFunction, item, true);
    });
  }
};

export const setFormDisplay = (formFunction: Record<string, Record<string, Function>>, item: string, display: boolean) => {
  const tfi = formFunction[item];
  if (tfi && tfi.setDisplay) {
    tfi.setDisplay(display);
  }
};

export const setFormMemo = (formMemo: Record<string, any> | undefined, field: string, data_name: string, data: any) => {
  if (formMemo) {
    if (!formMemo[field]) {
      formMemo[field] = {};
    }
    const memo = formMemo[field];
    if (memo) {
      if (memo) memo[data_name] = data;
    }
  }
};
export const getFormMemo = (formMemo: Record<string, any> | undefined, field: string, data_name?: string) => {
  if (formMemo) {
    if (!formMemo[field]) {
      formMemo[field] = {};
    }
    const memo = formMemo[field];
    if (memo) {
      return data_name ? memo[data_name] : memo;
    }
  }
  return undefined;
};

export const getInputFieldValue = (params: DataInputParams, field?: string) => {
  const sublist_field = field ?? params.subListName;
  const org_field = params.subListOrgName;

  return params.index !== undefined
    ? sublist_field && params.subListData instanceof Array && params.subListData[params.index]
      ? params.subListData[params.index][sublist_field] === undefined
        ? null
        : params.subListData[params.index][sublist_field]
      : sublist_field &&
          params.values &&
          params.subListTarget &&
          params.values[params.subListTarget] instanceof Array &&
          params.values[params.subListTarget][params.index]
        ? params.values[params.subListTarget][params.index][sublist_field] === undefined
          ? null
          : params.values[params.subListTarget][params.index][sublist_field]
        : org_field
          ? params.values[org_field + "_" + params.index]
          : undefined
    : sublist_field && params.subListData
      ? params.subListData[sublist_field]
      : sublist_field && params.subListTarget && params.values && params.values[params.subListTarget]
        ? params.values[params.subListTarget][sublist_field] === undefined
          ? null
          : params.values[params.subListTarget][sublist_field]
        : org_field && params.values
          ? params.values[org_field]
          : undefined;
};
export const getSubListValueField = (
  params_name?: string,
  params_subList?:
    | boolean
    | number
    | string
    | { target: string; labelField?: string; labelTransition?: boolean; valueField?: string | Record<string, string> },
) => {
  return params_subList instanceof Object && params_subList.valueField
    ? typeof params_subList.valueField === "string"
      ? params_subList.valueField
      : params_name && params_subList.valueField[params_name]
        ? params_subList.valueField[params_name]
        : params_name
    : params_name;
};
export const getSubListTarget = (col: DataInputCommonParams, field: string) => {
  if (col.subList) {
    return col.subList instanceof Object ? col.subList.target : typeof col.subList === "string" ? col.subList : field;
  } else {
    return undefined;
  }
};
export const getSubListData = (
  formFunction: Record<string, Record<string, Function>> | undefined,
  col: DataInputCommonParams,
  field: string,
  obj: any,
  setData: boolean,
  nullCheck?: boolean,
) => {
  if (col.subList) {
    const subDataTarget = col.subList instanceof Object ? col.subList.target : typeof col.subList === "string" ? col.subList : field;
    const subData_result: any[] = [];
    const subData_cols = getParamFields({ ...col, values: undefined });
    if (subData_cols) {
      delete subData_cols[field];
    }

    const subData_labelInputName = getLabelInputName({ ...col, values: undefined });
    if (subData_labelInputName && col.labelInput) {
      subData_cols[subData_labelInputName] = col.labelInput;
      getParamsFieldsCommon(col.labelInput, subData_cols);
    }

    //Debug(subData_cols);
    const { run, result } = runFormFunction(formFunction, field, "getCount");
    if (result) {
      getIntArray(result).forEach((i) => {
        const temp_result: Record<string, any> = {};
        let notNull = false;
        //값 입력
        Object.keys(subData_cols).forEach((temp_key) => {
          const temp_value = obj[temp_key + "_" + i];
          temp_result[temp_key] = temp_value;
          if (!notNull && temp_value !== undefined) {
            notNull = true;
          }
          if (setData) {
            delete obj[temp_key + "_" + i];
          }
        });
        if (setData) {
          Object.keys(subData_cols).forEach((temp_key) => {
            setScaledData(subData_cols[temp_key], temp_key, temp_result);
          });
        }
        if (!nullCheck || notNull) {
          subData_result.push(temp_result);
        }
      });

      if (setData) {
        obj[subDataTarget] = subData_result;
      }
      //
    }
    return subData_result;
  } else {
    return [];
  }
};
export const convertSubListToFormData = (params: DataInputParams, data: any) => {
  const params_name = params.name;
  const params_subList = params.subList;
  if (params_name && params_subList !== undefined) {
    const fieldIds: Record<string, DataInputCommonParams> = {};
    getParamsFieldsCommon(params, fieldIds, true);
    const fieldIdList = Object.keys(fieldIds);
    return convertSubListToFormDataDetail(params_name, params_subList, fieldIdList, data, fieldIds);
  } else {
    return undefined;
  }
};

export const convertSubListToFormDataDetail = (
  params_name: string,
  params_subList:
    | boolean
    | number
    | string
    | { target: string; labelField?: string; labelTransition?: boolean; valueField?: string | Record<string, string> },
  fieldIdList: string[],
  data: any,
  fieldIds?: Record<string, DataInputCommonParams>,
) => {
  const result: Record<string, any> = {};
  if (data instanceof Array) {
    data.forEach((item, index) => {
      convertSubListToFormDataCommon(result, item, params_name, params_subList, fieldIdList, fieldIds, index);
    });
    return result;
  } else {
    return convertSubListToFormDataCommon(result, data, params_name, params_subList, fieldIdList, fieldIds);
  }
};

const convertSubListToFormDataCommon = (
  result: Record<string, any>,
  data: any,
  params_name: string,
  params_subList:
    | boolean
    | number
    | string
    | { target: string; labelField?: string; labelTransition?: boolean; valueField?: string | Record<string, string> },
  fieldIdList: string[],
  fieldIds?: Record<string, DataInputCommonParams>,
  index?: number,
) => {
  fieldIdList.forEach((key) => {
    const SubListDataKey = getSubListValueField(key, params_subList);
    if (SubListDataKey && data) {
      //이부분에 컨버팅된 앖을 가져오게 하면 될듯.
      if (fieldIds && fieldIds[SubListDataKey]) {
        const keyParams = fieldIds[SubListDataKey];
        result[key + (index !== undefined ? "_" + index : "")] = convertInputTypeValue(
          data[SubListDataKey],
          keyParams.inputType,
          keyParams.scale,
          keyParams.dateFormatter,
        );
      } else {
        result[key + (index !== undefined ? "_" + index : "")] = data[SubListDataKey];
      }
    }
  });
  return result;
};

export const convertFormToSubListData = (
  data: any,
  params_subList:
    | boolean
    | number
    | string
    | { target: string; labelField?: string; labelTransition?: boolean; valueField?: string | Record<string, string> },
) => {
  //  const rev_field =  params_subList instanceof Object && params_subList.valueField instanceof
};
export const getSubListLabelField = (params: DataInputParams) => {
  return params.subList instanceof Object && params.subList.labelField ? params.subList.labelField : (params.subListName ?? params.name);
};

export const calSubListFieldsTotal = (
  form: FormInstance,
  formFunction: Record<string, Record<string, Function>>,
  subListName: string,
  totalField: string,
  field: string,
  percentField?: string,
  ratioFields?: Record<string, string>,
  // totalRatioField?: string,
  // ratioField?: string,
) => {
  const { run, result } = runFormFunction(formFunction, subListName, "getCount");
  const temp_fields: string[] = [];
  const ratio_fields: Record<string, string[]> = {};
  const ratio_field_all: string[] = [];
  const ratio_total: Record<string, number | undefined> = {};
  const ratio_field_keys = ratioFields ? Object.keys(ratioFields) : [];
  const array = Array.from({ length: result }, (_, i) => {
    temp_fields.push(field + "_" + i);
    if (ratioFields) {
      ratio_field_keys.forEach((key) => {
        if (!ratio_fields[key]) {
          ratio_fields[key] = [];
        }
        if (ratio_total[key] === undefined) {
          ratio_total[key] = 0;
        }
        const field = ratioFields[key];
        ratio_fields[key].push(field + "_" + i);
        ratio_field_all.push(field + "_" + i);
      });
    }
    return i;
  });
  const total_values = form.getFieldsValue([...temp_fields, ...ratio_field_all]);
  let total: number = 0;

  let check_all = true;
  let check_ratio = true;
  temp_fields.forEach((key, index: number) => {
    if (check_all && !checkEmpty(total_values[key])) {
      const temp_value = Number(total_values[key]);
      total += temp_value;
      if (check_ratio && ratioFields) {
        ratio_field_keys.forEach((ratio_field) => {
          const temp_field = ratio_fields[ratio_field][index];
          const temp_tatio_total = ratio_total[ratio_field];
          if (temp_field && temp_tatio_total !== undefined) {
            const temp_ratio = Number(total_values[temp_field]);
            ratio_total[ratio_field] = temp_tatio_total + temp_ratio * temp_value;
          } else {
            ratio_total[ratio_field] = undefined;
            if (Object.keys(ratio_total).every((ratio_field) => ratio_total[ratio_field] === undefined)) {
              check_ratio = false;
            }
          }
        });
      } else {
        if (check_ratio) {
          check_ratio = false;
        }
      }
    } else {
      if (check_all) {
        check_all = false;
      }
    }
  });
  const set_values: Record<string, any> = {};
  if (check_all && percentField) {
    array.forEach((i) => {
      const temp_value = total === 0 ? undefined : total_values[field + "_" + i];
      if (typeof temp_value === "number") {
        const value = temp_value !== undefined ? Math.round((temp_value * 1000) / total) / 10 : undefined;
        if (percentField === "label") {
          runFormFunction(formFunction, subListName + "_" + i, "setLabel", value !== undefined ? value + "%" : "");
          set_values[percentField + "_" + i] = undefined;
        } else {
          set_values[percentField + "_" + i] = value;
        }
      }
    });
  }
  set_values[totalField] = total === 0 ? undefined : total;
  if (check_ratio && !checkEmpty(ratio_total)) {
    Object.keys(ratio_total).forEach((temp_total) => {
      const temp_tatio_total = ratio_total[temp_total];
      set_values[temp_total] =
        temp_tatio_total === 0 || temp_tatio_total === undefined ? undefined : Math.round((temp_tatio_total * 10) / total) / 10;
    });
  }
  // Debug(totalField, field, temp_fields, total_values, set_values);
  form.setFieldsValue(set_values);
};

export const setSubListFieldOrder = (
  form: FormInstance,
  formFunction: Record<string, Record<string, Function>>,
  subListName: string,
  orderField: string,
) => {
  const { run, result } = runFormFunction(formFunction, subListName, "getCount");
  const set_values: Record<string, any> = {};
  Array.from({ length: result }, (_, i) => {
    set_values[orderField + "_" + i] = i + 1;
    return i;
  });
  form.setFieldsValue(set_values);
};

export const runSubListCommand = (
  form: FormInstance,
  formFunction: Record<string, Record<string, Function>>,
  subListName: string,
  subListFields: string[],
  index: number,
  move: number,
  remove?: boolean,
) => {
  const { run, result } = runFormFunction(formFunction, subListName, "getCount");
  const fixed_move = move === -1 ? result - 1 : move;
  if (run && result > 0 && fixed_move < result && fixed_move >= 0 && index !== fixed_move) {
    const temp_field_values: Record<string, any> = {};
    const temp_fields = subListFields.map((field) => field + "_" + index);
    const temp_values = form.getFieldsValue(temp_fields);
    subListFields.forEach((field) => {
      temp_field_values[field + "_" + fixed_move] = temp_values[field + "_" + index];
    });
    const direction = index < fixed_move;
    const start = direction ? index + 1 : fixed_move;
    const end = direction ? fixed_move : index - 1;
    const move_fields: string[] = [];
    const array = Array.from({ length: end - start + 1 }, (_, i) => {
      subListFields.forEach((field) => {
        move_fields.push(field + "_" + (i + start));
      });
      return i + start;
    });
    const move_values = form.getFieldsValue(move_fields);
    const move_field_values: Record<string, any> = {};
    const move_amount = direction ? -1 : 1;
    array.forEach((i) => {
      subListFields.forEach((field) => {
        move_field_values[field + "_" + (i + move_amount)] = move_values[field + "_" + i];
      });
    });
    // Debug(start, end, temp_field_values, move_values, move_field_values);
    form.setFieldsValue({ ...move_field_values, ...temp_field_values });
  }
  if (remove) {
    const reset_field_values: Record<string, any> = {};
    const remove_i = result - 1;
    subListFields.forEach((field) => {
      reset_field_values[field + "_" + remove_i] = undefined;
    });
    form.setFieldsValue(reset_field_values);
    runFormFunction(formFunction, subListName, "setCount", result - 1);
  }
  return result !== undefined ? (remove ? result - 1 : result) : undefined;
};

export const runFormFunction = (
  formFunction?: Record<string, Record<string, Function>>,
  field?: string | string[],
  fn?: string,
  arg?: any,
) => {
  // Debug("run Function - ", formFunction, field, fn, arg);
  // Debug(
  //   "run Function",
  //   formFunction && field ? formFunction[field] : undefined,
  //   formFunction && field && fn && formFunction[field] ? formFunction[field][fn] : undefined,
  // );
  if (formFunction && field && fn) {
    if (typeof field === "string" && formFunction[field] && formFunction[field][fn]) {
      const result = formFunction[field][fn](arg);
      return { run: true, result };
    } else if (field instanceof Array) {
      const result: any = {};
      field.forEach((id) => {
        if (formFunction[id] && formFunction[id][fn]) {
          result[id] = formFunction[id][fn](arg);
        }
      });
      return { run: true, result };
    }
  }
  return { run: false, result: undefined };
};

export const copyFormValue = (
  form: FormInstance | undefined,
  field: string,
  t: TransitionType | undefined,
  ta: TransitionType | undefined,
) => {
  try {
    if (form) {
      const value_str = form.getFieldValue(field);
      if (value_str !== undefined && value_str.trim() !== "") {
        navigator.clipboard.writeText(value_str);
        const field_name = t ? t(field) : field;
        //ta(check_obj.message, { field: field_name, value: check_obj.value }
        const copy_text = ta
          ? ta("field_copy_ok", { field: field_name })
          : t
            ? t("field_copy_ok", { field: field_name })
            : field_name + " copy ok";
        alert(copy_text);
      }
    }
  } catch (e) {}
};
export const focusFormField = (form: FormInstance | undefined, field: string) => {
  if (form) {
    form.scrollToField(field);
    const field_i = form.getFieldInstance(field);
    // Debug("error field", field_i);
    if (field_i && field_i.focus) {
      setTimeout(() => {
        field_i.focus();
      }, 200);
    }
  }
};
export const checkValueList = (
  valueList:
    | DefaultOptionType[]
    | {
        label?: string;
        value: InputTypeValue;
        disabled?: boolean;
        indeterminate?: boolean;
      }[]
    | undefined,
  value: any,
) => {
  if (valueList && value !== undefined) {
    let result = undefined;
    valueList.some((item) => {
      if (item.value === value || (typeof item.value === "number" && typeof value === "string" && item.value === Number(value))) {
        result = item.value;
        return true;
      } else {
        //Debug(item.value, typeof item.value, value, typeof value);
        return false;
      }
    });
    return result;
  } else {
    return value;
  }
};
export const setScaledData = (col: DataInputCommonParams, key: string, obj: any) => {
  if (col !== undefined && col.scale !== null && col.scale !== undefined && obj[key] !== null && obj[key] !== undefined) {
    obj[key] = obj[key] * col.scale;
  }

  if (obj[key] !== undefined && obj[key] !== null) {
    if (typeof obj[key] === "string") {
      if (col.inputDirect) {
        const target = getInputDirectTarget(col.inputDirect); //typeof col.inputDirect === "string" ? col.inputDirect : col.inputDirect.target;
        if (obj[key] === dv.input_direct) {
          obj[key] = undefined;
        } else if (target) {
          obj[target] = undefined;
        }
      } else if (obj[key].trim() === "") {
        obj[key] = undefined;
      }
    } else if (typeof obj[key] === "boolean" || obj[key] instanceof Boolean) {
      obj[key] = obj[key] ? 1 : 0;
    } else if (obj[key] instanceof Object) {
      const temp = obj[key];
      if (temp.$isDayjsObject) {
        obj[key] = getDayjsValueStr(obj[key] as Dayjs, col.inputType);
      } else if (obj[key] instanceof Array) {
        if (col.inputDirect) {
          if (obj[key].includes(dv.input_direct)) {
            obj[key] = obj[key].filter((key: string) => key !== dv.input_direct);
          } else {
            const target = getInputDirectTarget(col.inputDirect);
            if (target) {
              obj[target] = undefined;
            }
          }
        }

        if (obj[key].length > 0) {
          const join_str = col.valueJoin ?? ",";
          if (obj[key][0] instanceof Object) {
            let temp_str = "";
            obj[key].forEach((item: any, index: number) => {
              if (index !== 0) {
                temp_str += join_str;
              }
              if (item instanceof Object) {
                if (temp.$isDayjsObject) {
                  temp_str += getDayjsValueStr(item as Dayjs, col.inputType); //(item as Dayjs).toISOString().replace(/Z$/, "+00:00");
                } else {
                  temp_str += temp.toString();
                }
              } else {
                temp_str += item;
              }
            });
          } else {
            obj[key] = obj[key].join(join_str);
          }
        } else {
          obj[key] = undefined;
        }
      }
    }
  } else {
    const target = getInputDirectTarget(col.inputDirect);
    if (target) {
      obj[target] = undefined;
    }
  }
};
export const convertFormMemoValue = (
  form: FormInstance<any> | undefined,
  formMemo: Record<string, any> | undefined,
  inputMode: string | undefined,
  values: any | undefined,
  key: string,
  join?: string,
) => {
  const memoKey = formMemo && formMemo[key] ? formMemo[key] : undefined;
  const inputType = memoKey ? memoKey.inputType : undefined;
  const noItem = memoKey ? memoKey.noItem : undefined;
  const subListTarget: { target: string | undefined; name: string | undefined; index: number | undefined } =
    memoKey && memoKey.subListTarget ? memoKey.subListTarget : undefined;
  const noInstance = inputType && DatePickerTypeArray.includes(inputType);
  const temp_value =
    form && (form?.getFieldInstance(key) || (noInstance && inputMode !== "view"))
      ? form.getFieldValue(key)
      : subListTarget && subListTarget.target && subListTarget.name && subListTarget.index !== undefined
        ? values[subListTarget.target][subListTarget.index][subListTarget.name]
        : values[key];
  // Debug(key, inputMode, temp_value, values, values[key], memoKey);
  if (temp_value instanceof Object) {
    if (temp_value.$isDayjsObject) {
      return getDayjsValueStr(temp_value as Dayjs, inputType);
    } else if (temp_value instanceof Array) {
      let temp_str = "";
      const join_str = join ?? ",";
      temp_value.forEach((item: any, index: number) => {
        if (index !== 0) {
          temp_str += join_str;
        }
        if (item instanceof Object) {
          if (item.$isDayjsObject) {
            temp_str += getDayjsValueStr(item as Dayjs, inputType);
          } else {
            temp_str += item.toString();
          }
        } else {
          temp_str += item;
        }
      });
    } else {
      return temp_value;
    }
  } else {
    return temp_value;
  }
};
export const convertCalcValue = (
  value: any,
  values: any,
  calcValueProp?: CalcValueProps,
  inputType?: string,
  scale?: number,
  dateFormatter?: dateFormatterEx,
  sign?: boolean,
) => {
  return convertInputTypeValue(
    calcValueProp
      ? calcValueProp instanceof Function
        ? calcValue(values, calcValueProp)
        : calcValue(values, { ...calcValueProp, fixed: calcValueProp.fixed ?? (scale ? Math.log10(scale) : undefined) })
      : value,
    inputType,
    scale,
    dateFormatter,
    undefined,
    sign,
  );
};

export const convertInputTypeValue = (
  value: any,
  inputType?: string,
  scale?: number,
  dateFormatter?: dateFormatterEx,
  reverseConvert?: boolean,
  sign?: boolean,
) => {
  // Debug("convertInputTypeValue", value, inputType, scale);
  if (checkEmpty(value)) {
    return value;
  }
  if (inputType) {
    if (DatePickerTypeArray.includes(inputType) && (typeof value === "string" || typeof value === "number" || reverseConvert)) {
      if (reverseConvert) {
        return dayjs(value + dayjs().utcOffset() * 60000).valueOf();
      } else {
        if (sign && typeof value === "number" && dateFormatter) {
          // Debug(inputType, value, dateFormatter);
          return (
            (value < 0 ? "-" : value > 0 ? "+" : "") +
            getDayjsValueStr(getDayjsCommon(value, inputType), inputType, undefined, dateFormatter)
          );
        } else {
          if (dateFormatter) {
            return getDayjsValueStr(getDayjsCommon(value, inputType), inputType, undefined, dateFormatter);
          } else {
            return getDayjsCommon(value, inputType);
          }
        }
      }
    }
  }
  if (scale !== undefined) {
    const n_value = Number(value);
    if (isNaN(n_value)) {
      return value;
    }

    if (reverseConvert) {
      const c_value = Math.round(n_value * scale);
      return sign && c_value > 0 ? "+" + c_value : c_value;
    } else {
      return sign && n_value > 0 ? "+" + n_value / scale : n_value / scale;
    }
  }
  return value;
};

export const getLinkValue = (
  useHost: boolean | undefined,
  useEncode: boolean | undefined,
  site: string | undefined,
  pathname: LinkPathName | undefined,
  values: any | undefined,
  value: any | undefined,
  ids: string | string[] | undefined,
  join: string | undefined,
): string => {
  // Debug("getLinkValue start : ", site, values, value, ids, join);
  const regex = /^https?:\/\//i;
  const use_host = useHost ?? (regex.test(value) ? false : true);
  const use_encode = useEncode ?? use_host;
  const site_fix =
    site ??
    (use_host ? (checkDebug() ? window.location.origin.toString() : window.location.origin.toString()) : "") +
      (pathname && values
        ? typeof pathname === "string"
          ? pathname
          : typeof pathname === "function"
            ? pathname()
            : pathname.path[values[pathname.field]]
        : site || useHost
          ? "/"
          : "");
  const ids_arr = typeof ids === "string" ? [ids] : ids;
  if (value || (ids_arr && ids_arr.length > 0)) {
    const join_str = join ?? "_";
    const ids_value_str =
      values && ids_arr
        ? ids_arr
            .map((id) => {
              return use_encode ? encodeURIComponent(values[id]) : values[id];
            })
            .join(join_str)
        : undefined;
    const url = site_fix + (!checkEmpty(ids_value_str) ? ids_value_str + "_" : "") + (use_encode ? encodeURIComponent(value) : value);
    // Debug("LinkValue", url);
    return url;
  } else {
    Debug("value is empty", "|" + site_fix + "|");
    return "";
  }
};
